// document.addEventListener("DOMContentLoaded", async function () {
//   if (typeof window.Shopify !== "undefined" && window.Shopify.routes) {
//     const shopdomain = Shopify.shop || window.location.hostname;
//     const locale = window.Shopify.locale;
//     const market = document.getElementById('market-id').value ?? '';

//     // Clear selected location when market changes
//     const currentMarket = localStorage.getItem('current_market');
//     if (currentMarket !== market) {
//       localStorage.removeItem('selected_location');
//       localStorage.setItem('current_market', market);
//     }

//     function setInventoryData(key, value) {
//       // Double encoding to handle HTML content with attributes that can break JSON
//       const setdata = encodeURIComponent(JSON.stringify(value));
//       const expiryDate = new Date();
//       expiryDate.setMinutes(expiryDate.getMinutes() + 60);
//       document.cookie = `${key}_${market}=${setdata}; expires=${expiryDate.toUTCString()}; path=/`;
//     }

//     function getInventoryData(key) {
//       const cookies = document.cookie.split("; ");
//       for (let cookie of cookies) {
//         const [ckey, value] = cookie.split("=");
//         if (ckey === `${key}_${market}`) return value;
//       }
//       return null;
//     }

//     const getloc_inventory_stock = async () => {
//       const cached = getInventoryData("allInvntoryData");
//       // console.log('Cached data:', cached);
//       if (cached) {
//         try {
//           const recivieddata = JSON.parse(decodeURIComponent(cached));
//           return recivieddata;
//         } catch (e) {
//           console.error("Error parsing cached data:", e);
//           console.error("Invalid JSON:", cached); // Log the problematic JSON
//           return null; // Return null or handle the error gracefully
//         }
//       }

//       try {
//         var variant_id = 0;
//         var fromgeoblock = true;
//         var product_id = 0;
//         const url = `https://multilocation.techspawn.net/api/get-loc-inventory-stock?shopdomain=${encodeURIComponent(
//           shopdomain
//         )}&variant_id=${encodeURIComponent(
//           variant_id
//         )}&locale=${encodeURIComponent(
//           locale
//         )}&fromgeoblock=${encodeURIComponent(
//           fromgeoblock
//         )}&product_id=${encodeURIComponent(product_id)}&market=${encodeURIComponent(market)}`;
//         const result = await fetch(url, {
//           method: "GET",
//         });
//         if (!result.ok) {
//           throw new Error(`HTTP error! Status: ${result.status}`);
//         }
//         const data = await result.json();
//         // console.log('Fetched data:', data);
//         setInventoryData("allInvntoryData", data);
//         console.log("header-js for desktop");
//         return data;
//       } catch (error) {
//         console.error("Error:", error);
//       }
//     };

//     // Add a function to observe DOM changes and detect when an element is added
//     function waitForElement(selector, callback) {
//       // Check if element already exists
//       const element = document.querySelector(selector);
//       if (element) {
//         callback(element);
//         return;
//       }

//       // If not, set up a mutation observer to watch for it
//       const observer = new MutationObserver((mutations) => {
//         const element = document.querySelector(selector);
//         if (element) {
//           observer.disconnect();
//           callback(element);
//         }
//       });

//       // Start observing the document with the configured parameters
//       observer.observe(document.body, {
//         childList: true,
//         subtree: true,
//       });
//     }

//     function haversineDistance(lat1, lon1, lat2, lon2, distanceIN) {
//       const toRadians = (degrees) => degrees * (Math.PI / 180);
//       const R = 6371;
//       const dLat = toRadians(lat2 - lat1);
//       const dLon = toRadians(lon2 - lon1);
//       const a =
//         Math.sin(dLat / 2) * Math.sin(dLat / 2) +
//         Math.cos(toRadians(lat1)) *
//           Math.cos(toRadians(lat2)) *
//           Math.sin(dLon / 2) *
//           Math.sin(dLon / 2);
//       const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
//       let distance = R * c;
//       if (distanceIN === "false") {
//         distance *= 0.621371;
//       }
//       return distance;
//     }

//     var enabledSmartCollectionFilter = false;
//     let otherLocationMessage = "✔ Available in other locations";
//     let enabledOtherLocationMessage = false;
//     const display_location_stock = async (variant_id, baseUrl) => {
//       const allInvntoryData = await getloc_inventory_stock();
//       const invntorydata = allInvntoryData?.settings;
//       otherLocationMessage =
//         invntorydata?.otherLocationMessage ?? otherLocationMessage;
//       enabledOtherLocationMessage =
//         invntorydata?.enabledOtherLocationMessage ?? false;

//       const locationPopup = invntorydata?.locationPopup;
//       const locationPopupstyle = invntorydata?.locationPopupstyle;
//       // const locationSelectionType = invntorydata?.locationSelectionType;
//       const locationPopupHeader = invntorydata?.locationPopupHeader;
//       const locationPopupDescription = invntorydata?.locationPopupDescription;
//       // const locationarr = allInvntoryData?.settings?.locations_arr;
//       var locationarr = allInvntoryData.settings.locations_arr;
//       const locationSelectionType =
//         allInvntoryData.settings.locationSelectionType;
//       const headerBlock = allInvntoryData?.settings?.headerBlock;
//       const headerBlockstyle = allInvntoryData?.settings?.headerBlockstyle;
//       const enableGeolocationSearch =
//         invntorydata?.locationFilterSetting?.enableGeolocationSearch ?? "false";
//       const google_map_api_key =
//         invntorydata?.locationFilterSetting?.google_api_key ?? "";
//       const distanceIN = invntorydata?.distanceIN;
//       enabledSmartCollectionFilter =
//         allInvntoryData?.settings?.enabledSmartCollectionFilter;

//       function isFilterApplied() {
//         const urlParams = new URLSearchParams(window.location.search);
//         // Check for specific filter parameters in the URL
//         return (
//           urlParams.has("filter.p.tag") &&
//           urlParams.has("filter.v.m.multilocation_app.inventory_location")
//         );
//       }
//       window.locationPopupData = {
//         locationPopup,
//         locationPopupstyle,
//         locationSelectionType,
//         locationPopupHeader,
//         locationPopupDescription,
//         locationarr,
//       };

//       const locationNamesDropDown = document.getElementById(
//         "locationNamesDropDown"
//       );
//       const conatinerforall = document.createElement("div");
//       const locationNamesDropDownselect = document.createElement("select");
//       if (locationNamesDropDown && headerBlock === "true") {
//         locationNamesDropDown.innerHTML = "";
//         const loctionstore_icon = `<svg viewBox="0 0 24 24" focusable="false" width="24" height="24" aria-hidden="true" class="hnf-svg-icon"><path fill-rule="evenodd" clip-rule="evenodd" d="M2 4v16h20V4H2zm2 4V6h16v2H4zm0 2v8h3v-6h10v6h3v-8H4zm11 4h-2v4h2v-4zm-4 0H9v4h2v-4z"></path></svg>`;
//         locationNamesDropDown.insertAdjacentHTML(
//           "beforeend",
//           loctionstore_icon
//         );
//         const locations_arr = allInvntoryData.settings.locations_arr;

//         if (headerBlockstyle === "dropdown") {
//           locationNamesDropDownselect.id = "locationNamesDropDownselect";
//           locationNamesDropDownselect.name = "selected_location";
//           locationNamesDropDownselect.classList.add("location-dropdown");
//           const option = document.createElement("option");
//           option.value = "";
//           option.textContent = "Wähle deinen Standort";
//           locationNamesDropDownselect.appendChild(option);
//           for (const location of locations_arr) {
//             const option = document.createElement("option");
//             option.value = location.node.id.split("/").pop();
//             option.textContent = location.node.name;
//             locationNamesDropDownselect.appendChild(option);
//           }
//           locationNamesDropDown.appendChild(locationNamesDropDownselect);

//           // Sync dropdown selection with radio button selection
//           locationNamesDropDownselect.addEventListener("change", function () {
//             const selectedLocationId = locationNamesDropDownselect.value;

//             // Save the selected location to LocalStorage
//             localStorage.setItem("selected_location", selectedLocationId);

//             // Find the radio button that matches the selected location
//             const matchingRadioButton = document.querySelector(
//               `input[name="selected_location"][value="${selectedLocationId}"]`
//             );

//             if (matchingRadioButton) {
//               matchingRadioButton.checked = true;
//               if (locationSelectionType === "colorinversion") {
//                 const locationCard = matchingRadioButton.closest(
//                   ".location-card-listview"
//                 );
//                 if (locationCard) {
//                   // First remove any existing styles from all cards
//                   const allLocationCards = document.querySelectorAll(
//                     ".location-card-listview"
//                   );
//                   allLocationCards.forEach((card) => {
//                     card.style.removeProperty("background-color");
//                     card.style.removeProperty("color");
//                   });
//                   // Then set the styles for the selected card
//                   locationCard.style.backgroundColor =
//                     "rgb(var(--color-foreground))";
//                   locationCard.style.color = "rgb(var(--color-background))";
//                 }
//               }
//             }
//             updateCollectionInventory();
//           });
//         }

//         if (headerBlockstyle === "popup") {
//           const locationshowonheader = document.createElement("div");
//           locationshowonheader.classList.add("location-popup-header");
//           locationshowonheader.id = "location-popup-header-id";
//           const savelocationid = localStorage.getItem("selected_location");
//           if (
//             savelocationid == null ||
//             savelocationid == undefined ||
//             savelocationid == "undefined" ||
//             savelocationid == ""
//           ) {
//             locationshowonheader.textContent = "Wähle deinen Standort";
//           } else {
//             for (const location of locations_arr) {
//               if (location.node.id.split("/").pop() == savelocationid) {
//                 locationshowonheader.textContent = location.node.name;
//               }
//             }
//           }
//           locationNamesDropDown.appendChild(locationshowonheader);
//           locationshowonheader.addEventListener("click", function () {
//             document.dispatchEvent(new CustomEvent("openLocationPopup"));
//           });
//         }

//         if (headerBlockstyle === "drawer") {
//           console.log("headerBlockstyle", headerBlockstyle);

//           const locationshowonheader = document.createElement("div");
//           locationshowonheader.classList.add("location-popup-header");
//           locationshowonheader.id = "location-popup-header-id";
//           console.log("locationshowonheader_run3", locationshowonheader);
//           const savelocationid = localStorage.getItem("selected_location");
//           if (
//             savelocationid == null ||
//             savelocationid == undefined ||
//             savelocationid == "undefined" ||
//             savelocationid == ""
//           ) {
//             locationshowonheader.textContent = "Wähle deinen Standort";
//           } else {
//             for (const location of locations_arr) {
//               if (location.node.id.split("/").pop() == savelocationid) {
//                 locationshowonheader.textContent = location.node.name;
//               }
//             }
//           }
//           locationNamesDropDown.appendChild(locationshowonheader);
//           locationshowonheader.addEventListener("click", function () {
//             console.log("run");
//             const savelocationid = localStorage.getItem("selected_location");
//             console.log(savelocationid, "savelocationid_run");
//             const drawerOverlay = document.createElement("div");
//             drawerOverlay.id = "inventoryDrawerOverlay";
//             drawerOverlay.classList.add("multiloca-inventory-drawer-overlay");
//             drawerOverlay.addEventListener("click", function (event) {
//                 if (event.target === drawerOverlay) {
//                     drawerContent.style.animation =
//                         ".2s ease-out slidedown-location-drawer";
//                     setTimeout(() => {
//                         document.body.removeChild(drawerOverlay);
//                     }, 200);
//                 }
//             });
//             const drawerContent = document.createElement("div");
//             drawerContent.id = "inventoryDrawerContent";
//             drawerContent.classList.add("multiloca-inventory-drawer-content");
//             drawerContent.style.animation =
//               ".4s ease-out slideup-location-drawer";

//             const drawerHeader = document.createElement("div");
//             drawerHeader.id = "inventoryDrawerHeader";
//             drawerHeader.classList.add("custom_drawer__header");

//             const drawerTitle = document.createElement("h2");
//             drawerTitle.id = "inventoryDrawerTitle";
//             drawerTitle.classList.add("multiloca-inventory-drawer-title");
//             drawerTitle.textContent = "Wähle deinen Standort";
//             drawerHeader.appendChild(drawerTitle);
//             drawerContent.appendChild(drawerHeader);

//             const closeButton = document.createElement("button");
//             closeButton.id = "closeDrawerButton";
//             closeButton.classList.add("multiloca-close-drawer-button");
//             closeButton.textContent = "X";
//             closeButton.addEventListener("click", function () {
//               drawerContent.style.animation =
//                 ".2s ease-out slidedown-location-drawer";
//               setTimeout(() => {
//                 document.body.removeChild(drawerOverlay);
//               }, 200);
//             });
//             drawerContent.appendChild(closeButton);

//             const locationsContainer = document.createElement("div");
//             locationsContainer.id = "drawerLocationsContainer";
//             locationsContainer.style.backgroundColor = "#f5f5f5";
//             drawerContent.appendChild(locationsContainer);

//             //geolocation code
//             const geolocationSearch = document.createElement("div");
//             const geolocationSearchInput = document.createElement("input");
//             const usemylocation = document.createElement("a");
//             const searchIcon = document.createElement("span");
//             const predictionlocationNames = [];
//             if (enableGeolocationSearch == "true" && google_map_api_key != "") {
//               const googlePlacesScript = document.createElement("script");
//               googlePlacesScript.src = `https://maps.googleapis.com/maps/api/js?key=${google_map_api_key}&libraries=places`;
//               document.head.appendChild(googlePlacesScript);
//               geolocationSearch.classList.add("geolocation-search");
//               geolocationSearchInput.type = "text";
//               geolocationSearchInput.placeholder =
//                 "Enter address, zip code or city";
//               geolocationSearchInput.classList.add("geolocation-search-input");
//               searchIcon.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 96 960 960" width="20"><path d="M796 876 590 670q-34 29-72.5 44t-82.5 15q-108 0-183.5-75.5T176 470q0-108 75.5-183.5T435 211q108 0 183.5 75.5T694 470q0 45-14 85t-44 75l207 207q9 9 9 21t-9 21l-29 29q-9 9-21 9t-21-9ZM436 674q75 0 127.5-52.5T616 470q0-75-52.5-127.5T436 290q-75 0-127.5 52.5T256 470q0 75 52.5 127.5T436 674Z"/></svg>`;
//               searchIcon.classList.add("search-icon");
//               usemylocation.innerHTML = `
//                                         <svg viewBox="0 0 24 24" focusable="false" width="24" height="24" aria-hidden="true" class="hnf-svg-icon hnf-btn__icon"><path d="M12 15c1.6569 0 3-1.3431 3-3s-1.3431-3-3-3-3 1.3431-3 3 1.3431 3 3 3z"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M18.9205 13H21v-2h-2.0795A6.9929 6.9929 0 0 0 13 5.08V3h-2v2.08A6.9928 6.9928 0 0 0 5.08 11H3v2h2.08A6.9924 6.9924 0 0 0 11 18.9205V21h2v-2.0795A6.9927 6.9927 0 0 0 18.9205 13zm-2.7632-3.7779A4.9993 4.9993 0 0 1 17 12a5.006 5.006 0 0 1-1.4661 3.5339A5.006 5.006 0 0 1 12 17a5 5 0 1 1 4.1573-7.7779z"></path></svg>`;
//               usemylocation.classList.add("use-my-location");
//               usemylocation.href = "#";
//               usemylocation.addEventListener("click", async (e) => {
//                 e.preventDefault();
//                 try {
//                   const position = await new Promise((resolve, reject) => {
//                     navigator.geolocation.getCurrentPosition(resolve, reject);
//                   });
//                   cust_lat = position.coords.latitude;
//                   cust_lng = position.coords.longitude;
//                   geolocationSearchInput.value = "";
//                   const detailsUrl = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${cust_lat},${cust_lng}&key=${google_map_api_key}`;
//                   fetch(detailsUrl)
//                     .then((response) => response.json())
//                     .then((details) => {
//                       if (details.results && details.results.length > 0) {
//                         const components =
//                           details.results[0].address_components;
//                         const address = components.find((component) =>
//                           component.types.includes("street_number")
//                         );
//                         const city = components.find((component) =>
//                           component.types.includes("locality")
//                         );
//                         const state = components.find((component) =>
//                           component.types.includes(
//                             "administrative_area_level_1"
//                           )
//                         );
//                         const zip = components.find((component) =>
//                           component.types.includes("postal_code")
//                         );
//                         const country = components.find((component) =>
//                           component.types.includes("country")
//                         );
//                         geolocationSearchInput.value = `${
//                           address ? address.long_name : ""
//                         } ${city ? city.long_name : ""} ${
//                           state ? state.long_name : ""
//                         } ${zip ? zip.long_name : ""} ${
//                           country ? country.long_name : ""
//                         }`;

//                         locations_arr.forEach((loc) => {
//                           var corrdiloc =
//                             loc.node.address.latitude +
//                             "," +
//                             loc.node.address.longitude;
//                           let locCoords = corrdiloc ? corrdiloc.split(",") : [];
//                           locCoords[0] = parseFloat(locCoords[0]);
//                           locCoords[1] = parseFloat(locCoords[1]);
//                           loc.distance = haversineDistance(
//                             cust_lat,
//                             cust_lng,
//                             locCoords[0],
//                             locCoords[1],
//                             distanceIN
//                           );
//                           if (Number.isNaN(loc.distance)) {
//                             loc.distance = "-";
//                           }
//                         });
//                         locations_arr.sort((a, b) => {
//                           if (a.distance === "-" && b.distance === "-")
//                             return 0;
//                           if (a.distance === "-") return 1;
//                           if (b.distance === "-") return -1;
//                           return a.distance - b.distance;
//                         });
//                         showfilrterdlocations(locations_arr);
//                       }
//                     })
//                     .catch((error) => {
//                       console.error("Error fetching place details:", error);
//                     });
//                 } catch (error) {
//                   console.error(error);
//                 }
//               });
//               console.log(locations_arr);
//               geolocationSearch.appendChild(searchIcon);
//               geolocationSearch.appendChild(geolocationSearchInput);
//               geolocationSearch.appendChild(usemylocation);

//               locationsContainer.appendChild(geolocationSearch);
//               // locationsContainer.appendChild(usemylocation);
//               const a = document.createElement("div");
//               a.classList.add("autocomplete-items");
//               geolocationSearch.appendChild(a);

//               let addalready = false;
//               geolocationSearchInput.addEventListener(
//                 "input",
//                 function (event) {
//                   const searchValue = event.target.value;

//                   if (addalready == false) {
//                     addalready = true;
//                     usemylocation.innerHTML = searchIcon.innerHTML;
//                   }
//                   searchIcon.innerHTML = "";

//                   if (searchValue === "") {
//                     addalready = false;
//                     searchIcon.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 96 960 960" width="20"><path d="M796 876 590 670q-34 29-72.5 44t-82.5 15q-108 0-183.5-75.5T176 470q0-108 75.5-183.5T435 211q108 0 183.5 75.5T694 470q0 45-14 85t-44 75l207 207q9 9 9 21t-9 21l-29 29q-9 9-21 9t-21-9ZM436 674q75 0 127.5-52.5T616 470q0-75-52.5-127.5T436 290q-75 0-127.5 52.5T256 470q0 75 52.5 127.5T436 674Z"/></svg>`;
//                     usemylocation.innerHTML = `<svg viewBox="0 0 24 24" focusable="false" width="24" height="24" aria-hidden="true" class="hnf-svg-icon hnf-btn__icon"><path d="M12 15c1.6569 0 3-1.3431 3-3s-1.3431-3-3-3-3 1.3431-3 3 1.3431 3 3 3z"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M18.9205 13H21v-2h-2.0795A6.9929 6.9929 0 0 0 13 5.08V3h-2v2.08A6.9928 6.9928 0 0 0 5.08 11H3v2h2.08A6.9924 6.9924 0 0 0 11 18.9205V21h2v-2.0795A6.9927 6.9927 0 0 0 18.9205 13zm-2.7632-3.7779A4.9993 4.9993 0 0 1 17 12a5.006 5.006 0 0 1-1.4661 3.5339A5.006 5.006 0 0 1 12 17a5 5 0 1 1 4.1573-7.7779z"></path></svg>`;
//                     a.innerHTML = "";
//                     return;
//                   }

//                   const autocompleteService =
//                     new google.maps.places.AutocompleteService();

//                   autocompleteService.getPlacePredictions(
//                     { input: searchValue },
//                     (predictions, status) => {
//                       if (
//                         status === google.maps.places.PlacesServiceStatus.OK
//                       ) {
//                         predictions.forEach((prediction) => {
//                           predictionlocationNames.push({
//                             description: prediction.description,
//                             placeId: prediction.place_id,
//                           });
//                         });
//                       } else {
//                         console.error("Error fetching predictions:", status);
//                       }
//                     }
//                   );

//                   a.innerHTML = "";
//                   var loc_lat;
//                   var loc_lng;
//                   const filteredNames = predictionlocationNames.filter((n) =>
//                     n.description
//                       .toLowerCase()
//                       .includes(searchValue.toLowerCase())
//                   );
//                   filteredNames.slice(0, 5).forEach((name) => {
//                     let uniqueId = `placeId-${Math.random()
//                       .toString(36)
//                       .substr(2, 9)}`;
//                     const b = document.createElement("div");
//                     b.innerHTML =
//                       "<strong>" +
//                       name.description.substr(0, searchValue.length) +
//                       "</strong>";
//                     b.innerHTML += name.description.substr(searchValue.length);
//                     b.innerHTML +=
//                       "<input type='hidden' value='" + name.description + "'>";
//                     b.innerHTML += `<input type='hidden' value='${name.placeId}' id='${uniqueId}'>`;
//                     b.addEventListener("click", function (e) {
//                       const selectedPlaceId =
//                         document.getElementById(uniqueId).value;
//                       geolocationSearchInput.value =
//                         this.getElementsByTagName("input")[0].value;
//                       const detailsUrl = `https://maps.googleapis.com/maps/api/place/details/json?place_id=${selectedPlaceId}&key=${google_map_api_key}`;
//                       fetch(detailsUrl)
//                         .then((response) => response.json())
//                         .then((details) => {
//                           if (details.result.geometry) {
//                             loc_lat = details.result.geometry.location.lat;
//                             loc_lng = details.result.geometry.location.lng;

//                             locations_arr.forEach((loc) => {
//                               var corrdiloc =
//                                 loc.node.address.latitude +
//                                 "," +
//                                 loc.node.address.longitude;
//                               let locCoords = corrdiloc
//                                 ? corrdiloc.split(",")
//                                 : [];
//                               locCoords[0] = parseFloat(locCoords[0]);
//                               locCoords[1] = parseFloat(locCoords[1]);
//                               loc.distance = haversineDistance(
//                                 loc_lat,
//                                 loc_lng,
//                                 locCoords[0],
//                                 locCoords[1]
//                               );
//                               if (Number.isNaN(loc.distance)) {
//                                 loc.distance = "-";
//                               }
//                             });
//                             locations_arr.sort((a, b) => {
//                               if (a.distance === "-" && b.distance === "-")
//                                 return 0;
//                               if (a.distance === "-") return 1;
//                               if (b.distance === "-") return -1;
//                               return a.distance - b.distance;
//                             });
//                             showfilrterdlocations(locations_arr);
//                           } else {
//                             console.error(
//                               "No geometry data available for this place."
//                             );
//                           }
//                         })
//                         .catch((error) => {
//                           console.error("Error fetching place details:", error);
//                         });
//                       a.innerHTML = "";
//                     });
//                     a.appendChild(b);
//                   });
//                 }
//               );
//             }

//             showfilrterdlocations(locations_arr);
//             function showfilrterdlocations(locations_arr) {
//               //clear all location card from locationsContainer
//               const locationcontainer = document.querySelectorAll(
//                 ".locationCardDrawerView"
//               );
//               if (locationcontainer) {
//                 locationcontainer.forEach((loc) => {
//                   loc.remove();
//                 });
//               }
//               for (const location of locations_arr) {
//                 const locationCard = document.createElement("div");
//                 locationCard.classList.add("locationCardDrawerView");
//                 if (location.node.id.split("/").pop() == savelocationid) {
//                   locationCard.classList.add(
//                     "location-card-drawer-list-view-selected"
//                   );
//                 } else {
//                   locationCard.classList.add("location-card-drawer-list-view");
//                 }
//                 locationCard.setAttribute(
//                   "data-location-id",
//                   location.node.id.split("/").pop()
//                 );

//                 const locationNameshow = document.createElement("div");
//                 locationNameshow.classList.add(
//                   "location-card-drawer-list-view-name"
//                 );
//                 locationNameshow.textContent = location.node.name;
//                 locationCard.appendChild(locationNameshow);

//                 const locationAddress = document.createElement("div");
//                 locationAddress.classList.add(
//                   "location-card-drawer-list-view-address"
//                 );
//                 for (const address of location.node.address.formatted) {
//                   locationAddress.innerHTML += address + "<br />";
//                 }
//                 locationCard.appendChild(locationAddress);
//                 locationsContainer.appendChild(locationCard);

//                 locationCard.addEventListener("click", function () {
//                   const selectedLocationId =
//                     locationCard.getAttribute("data-location-id");
//                   localStorage.setItem("selected_location", selectedLocationId);
//                   setTimeout(() => {
//                     // Remove the selected class from all location cards
//                     const allLocationCards = document.querySelectorAll(
//                       ".location-card-drawer-list-view-selected"
//                     );
//                     console.log(allLocationCards);
//                     allLocationCards.forEach((card) => {
//                       console.log(card);
//                       card.classList.remove(
//                         "location-card-drawer-list-view-selected"
//                       );
//                       card.classList.add("location-card-drawer-list-view");
//                     });
//                     console.log(locationCard);
//                     // Add the selected class to the clicked card
//                     locationCard.classList.remove(
//                       "location-card-drawer-list-view"
//                     );
//                     locationCard.classList.add(
//                       "location-card-drawer-list-view-selected"
//                     );
//                     locationCard.dataset.selected = true;

//                     // Update the header location name
//                     locationshowonheader.textContent = location.node.name;

//                     // Close the drawer
//                     document.body.removeChild(drawerOverlay);
//                   }, 50); // Delay of 50ms
//                   // Trigger change event for the dropdown
//                   updateCollectionInventory();

//                   if (
//                     enabledSmartCollectionFilter === true ||
//                     enabledSmartCollectionFilter === "true"
//                   ) {
//                     if (window.location.pathname.includes("/collections/")) {
//                       updateFilterURL(location.node.name);
//                       applyShopifyFilter();
//                     }
//                   }

//                   // const event = new Event('change', { bubbles: true });
//                   // locationNamesDropDownselect.dispatchEvent(event);

//                   // Call showlocations function if it's accessible
//                   if (window.multiLocationShowLocations) {
//                     window.multiLocationShowLocations(selectedLocationId);
//                   }
//                 });
//               }
//             }

//             // Append the drawer content to the overlay
//             drawerOverlay.appendChild(drawerContent);

//             // Append the overlay to the body
//             document.body.appendChild(drawerOverlay);
//           });
//         }

//         // After appending the dropdown to the DOM

//         updateCollectionInventory();
//         locationNamesDropDownselect.addEventListener("change", function () {
//           const selectedLocationId = locationNamesDropDownselect.value;
//           localStorage.setItem("selected_location", selectedLocationId);

//           // Get all product pages' radio buttons that match the selected location
//           const matchingRadioButtons = document.querySelectorAll(
//             `input[name="selected_location"][value="${selectedLocationId}"]`
//           );
//           matchingRadioButtons.forEach((radio) => {
//             radio.checked = true;

//             // Dispatch a custom click event to ensure any associated event handlers run
//             const clickEvent = new Event("change", { bubbles: true });
//             radio.dispatchEvent(clickEvent);

//             // Apply styling if needed
//             if (locationSelectionType === "colorinversion") {
//               const locationCard = radio.closest(".location-card-listview");
//               if (locationCard) {
//                 // Reset all cards
//                 const allLocationCards = document.querySelectorAll(
//                   ".location-card-listview"
//                 );
//                 allLocationCards.forEach((card) => {
//                   card.style.removeProperty("background-color");
//                   card.style.removeProperty("color");
//                 });
//                 // Style the selected card
//                 locationCard.style.backgroundColor =
//                   "rgb(var(--color-foreground))";
//                 locationCard.style.color = "rgb(var(--color-background))";
//               }
//             }
//           });

//           // Call showlocations function if it's accessible
//           if (window.multiLocationShowLocations) {
//             window.multiLocationShowLocations(selectedLocationId);
//           }

//           console.log("Location changed to:", selectedLocationId);
//         });
//       } else {
//         locationNamesDropDown.innerHTML = "";
//       }

//       const savedLocationId = localStorage.getItem("selected_location");
//       if (savedLocationId) {
//         locationNamesDropDownselect.value = savedLocationId;
//       }
//     };

//     // Wait for the header location dropdown to be added to the DOM
//     waitForElement("#locationNamesDropDownselect", (headerLocationDropdown) => {
//       headerLocationDropdown.addEventListener("change", function () {
//         const selectedLocationId = headerLocationDropdown.value;
//         localStorage.setItem("selected_location", selectedLocationId);
//         console.log("Header location changed to:", selectedLocationId);

//         // Dispatch a custom event that other scripts can listen for
//         const event = new CustomEvent("locationChanged", {
//           detail: { locationId: selectedLocationId },
//         });
//         document.dispatchEvent(event);
//         updateCollectionInventory();
//       });
//     });

//     display_location_stock();

//     // Header block base locations collection filter
//     function attachDropdownListener(locationDropdown) {
//       locationDropdown.addEventListener("change", function () {
//         let selectedOption =
//           locationDropdown.options[locationDropdown.selectedIndex];
//         let selectedLocation = selectedOption
//           ? selectedOption.textContent.trim()
//           : null;
//         if (selectedLocation) {
//           let filterCheckboxes = document.querySelectorAll(
//             'input[type="checkbox"]'
//           );
//           let locationMatched = false;
//           filterCheckboxes.forEach((checkbox) => {
//             let label = checkbox.closest("label");
//             let labelText = label ? label.textContent.trim() : "";
//             if (labelText.includes(selectedLocation)) {
//               checkbox.checked = true;
//               locationMatched = true;
//             } else {
//               checkbox.checked = false;
//             }
//           });

//           if (locationMatched) {
//             updateFilterURL(selectedLocation);
//             applyShopifyFilter();
//           } else {
//             console.warn("No matching checkbox found for:", selectedLocation);
//           }
//         }
//       });
//     }

//     function isCollectionPage() {
//       // Check if the current URL contains "/collections/"
//       return window.location.pathname.includes("/collections/");
//     }

//     // function updateFilterURL(location) {
//     //   if (!isCollectionPage()) {
//     //     console.log(
//     //       "Filter not applied: Current page is not a collection page."
//     //     );
//     //     return;
//     //   }

//     //   let currentURL = new URL(window.location.href);
//     //   currentURL.searchParams.set("filter.p.tag", location);
//     //   currentURL.searchParams.set(
//     //     "filter.v.m.multilocation_app.inventory_location",
//     //     location
//     //   );
//     //   window.history.pushState({}, "", currentURL.toString());
//     //   applyShopifyFilter();
//     // }
//     function updateFilterURL(location) {
//       let currentURL = new URL(window.location.href);
//       currentURL.searchParams.set("filter.p.tag", location);
//       currentURL.searchParams.set(
//         "filter.v.m.multilocation_app.inventory_location",
//         location
//       );
//       window.history.pushState({}, "", currentURL.toString());
//       applyShopifyFilter();
//     }
//     function applyShopifyFilter() {
//       if (
//         window.Shopify &&
//         window.Shopify.theme &&
//         window.Shopify.theme.handleFilters
//       ) {
//         window.Shopify.theme.handleFilters();
//       } else {
//         location.reload();
//       }
//     }

//     function handleDrawerLocationSelection(locationCard, locationName) {
//       const selectedLocationId = locationCard.getAttribute("data-location-id");

//       // Save the selected location to LocalStorage
//       localStorage.setItem("selected_location", selectedLocationId);

//       // Update the header location name
//       const locationshowonheader = document.getElementById(
//         "location-popup-header-id"
//       );

//       console.log("locationshowonheader_run", locationshowonheader);
//       if (locationshowonheader) {
//         locationshowonheader.textContent = locationName;
//       }

//       // Apply the filter dynamically
//       console.log("Applying filter for drawer location:", locationName);
//       updateFilterURL(locationName);
//       applyShopifyFilter();

//       // Dispatch a custom event to notify other parts of the app
//       const event = new CustomEvent("locationChanged", {
//         detail: { locationId: selectedLocationId },
//       });
//       document.dispatchEvent(event);
//     }

//     const observer = new MutationObserver(() => {
//       let locationDropdown = document.getElementById(
//         "locationNamesDropDownselect"
//       );
//       if (locationDropdown) {
//         observer.disconnect();
//         if (
//           enabledSmartCollectionFilter === true ||
//           enabledSmartCollectionFilter === "true"
//         ) {
//           attachDropdownListener(locationDropdown);
//         }
//       }
//     });
//     observer.observe(document.body, { childList: true, subtree: true });

//     document.querySelectorAll("variant-radios").forEach((variantRadio) => {
//       const variantDataScript = variantRadio.querySelector(
//         'script[type="application/json"]'
//       );
//       if (!variantDataScript) return;

//       const variantData = JSON.parse(variantDataScript.textContent);
//       const radioInputs = variantRadio.querySelectorAll('input[type="radio"]');

//       radioInputs.forEach((input) => {
//         input.addEventListener("change", () => {
//           const selectedOptionValue = input.value;
//           const matchingVariant = variantData.find(
//             (variant) => variant.title === selectedOptionValue
//           );

//           if (!matchingVariant) {
//             console.warn(
//               "No matching variant found for selected option:",
//               selectedOptionValue
//             );
//             return;
//           }

//           const selectedVariantId = matchingVariant.id;
//           const productId = variantRadio.getAttribute("data-product");

//           const card = document.querySelector(
//             `.multilocation_product-card[data-product-id="${productId}"]`
//           );

//           if (!card) {
//             console.warn(`No product card found for product ID: ${productId}`);
//             return;
//           }

//           const variantWrapper = card.querySelector(".multi_variant_id");
//           if (variantWrapper) {
//             variantWrapper.setAttribute("data-variant-id", selectedVariantId);
//             updateInventoryForCard(card, selectedVariantId);
//           }
//         });
//       });
//     });

//     // function updateInventoryForCard(card, variantId) {
//     //   const selectedLocationId = localStorage.getItem("selected_location");
//     //   const inventoryStatus = card.querySelector(".multiloc_inventory-status");
//     //   const inventoryContainer = card.querySelector(
//     //     ".multiloc_inventory-container"
//     //   );

//     //   if (
//     //     !variantId ||
//     //     !window.inventoryData ||
//     //     !window.inventoryData.inventoryMap[variantId]
//     //   ) {
//     //     inventoryStatus.innerHTML = `
//     //       <span style="color:gray;">Keine Daten für ausgewählte Variante</span>
//     //     `;
//     //     return;
//     //   }

//     //   const variantData = window.inventoryData.inventoryMap[variantId];
//     //   inventoryContainer.innerHTML = "";

//     //   if (
//     //     !variantData.inventoryLevels ||
//     //     variantData.inventoryLevels.length === 0
//     //   ) {
//     //     inventoryStatus.innerHTML = `
//     //       <span style="color:gray;">Keine Lagerdaten verfügbar</span>
//     //     `;
//     //     return;
//     //   }

//     //   const selectedLocationInventory = variantData.inventoryLevels.filter(
//     //     (level) => level.location_id === selectedLocationId
//     //   );

//     //   if (selectedLocationInventory.length === 0) {
//     //     inventoryStatus.innerHTML = `
//     //       <span style="display:inline-block; width:10px; height:10px; background-color:#f7931e; border-radius:50%; margin-right:5px;"></span>
//     //       <span style="color:#f7931e;">Nicht Verfügbar am gewählten Standort</span>
//     //     `;
//     //     return;
//     //   }

//     //   let stockAvailable = false;
//     //   let stockother = false;
//     //   let locationName = "";

//     //   selectedLocationInventory.forEach((level) => {
//     //     const { location_name, available_quantity } = level;
//     //     const stockLine = document.createElement("div");
//     //     stockLine.textContent = `${location_name}: ${
//     //       available_quantity > 0 ? "Verfügbar" : "Wir arbeiten an Nachschub"
//     //     } (${available_quantity})`;
//     //     inventoryContainer.appendChild(stockLine);

//     //     if (available_quantity > 0) {
//     //       stockAvailable = true;
//     //       locationName = location_name;
//     //     }
//     //     const allLocationsInventory = variantData.inventoryLevels.filter(
//     //       (level) => level.available_quantity > 0
//     //     );
//     //     const otherLocationsWithStock = allLocationsInventory.filter(
//     //       (level) =>
//     //         String(level.location_id) !== String(selectedLocationId) &&
//     //         level.available_quantity > 0
//     //     );

//     //     if (
//     //       !stockAvailable &&
//     //       otherLocationsWithStock.length > 0 &&
//     //       enabledOtherLocationMessage === "true"
//     //     ) {
//     //       stockother = true;
//     //     }
//     //   });

//     //   if (stockAvailable) {
//     //     inventoryStatus.innerHTML = `
//     //       <span style="font-size: 10px;">🟢</span>
//     //       <span style="color:#3abf62;font-size:15px;">Verfügbar in ${locationName}</span>
//     //     `;
//     //   } else {
//     //     inventoryStatus.innerHTML = `
//     //       <span style="font-size: 10px;">🔴</span>
//     //       <span style="color:#ff5858;font-size:15px;">Wir arbeiten an Nachschub</span>
//     //     `;
//     //   }
//     //   if (stockother) {
//     //     inventoryStatus.innerHTML = `
//     //       <span style="font-size: 10px;">🟠</span>
//     //       <span style="color:#FFA500;font-size:15px;">An anderen Standorten verfügbar</span>
//     //     `;
//     //   }
//     // }

//     function updateInventoryForCard(card, variantId) {
//   try {
//     const enabledOtherLocationMessage = window.enabledOtherLocationMessage ?? "true";
//     const selectedLocationId = localStorage.getItem("selected_location"); // string
//     const inventoryStatus = card.querySelector(".multiloc_inventory-status");
//     const inventoryContainer = card.querySelector(".multiloc_inventory-container");

//     // --- helper: find all possible add-to-cart buttons ---
//     function findAddToCartButtons() {
//       let btns = Array.from(card.querySelectorAll(
//         "button[name='add'], \
//          button.product__add-cart, \
//          button.product-item__button-submit, \
//          form[action*='/cart/add'] button[type='submit']"
//       )).filter(Boolean);
//      console.log("btns",btns);
//       if (btns.length) return btns;

//       // fallback: check ancestor card/form
//       const anc = card.closest(".product-item, .product-card, .product-card-wrapper, product-form, form");
//       if (anc) {
//         btns = Array.from(anc.querySelectorAll(
//           "button[name='add'], \
//            button.product__add-cart, \
//            button.product-item__button-submit, \
//            form[action*='/cart/add'] button[type='submit']"
//         )).filter(Boolean);
//         if (btns.length) return btns;
//       }

//       // last-resort: all add-to-cart buttons on page
//       btns = Array.from(document.querySelectorAll(
//         "button[name='add'], form[action*='/cart/add'] button[type='submit']"
//       )).filter(Boolean);

//       return btns;
//     }

//     const addToCartBtns = findAddToCartButtons();
//     console.log("Found buttons for card:", addToCartBtns);

//     // store original text for restoring
//     addToCartBtns.forEach((b) => {
//       if (!b.dataset.originalText) {
//         const span = b.querySelector(".btn-action, .add-to-cart-text, span");
//         b.dataset.originalText = span ? span.textContent.trim() : b.textContent.trim();
//       }
//     });

//     function setButtonsDisabled(disabled) {
//       addToCartBtns.forEach((btn) => {
//         btn.disabled = !!disabled;
//         if (disabled) {
//           btn.setAttribute("aria-disabled", "true");
//           btn.classList.add("is-disabled", "disabled");
//           btn.style.opacity = ".5";
//           btn.style.pointerEvents = "none";

//           const span = btn.querySelector(".btn-action, .add-to-cart-text, span");
//           if (span) span.textContent = "Nicht verfügbar";
//           else btn.textContent = "Nicht verfügbar";
//         } else {
//           btn.removeAttribute("aria-disabled");
//           btn.classList.remove("is-disabled", "disabled");
//           btn.style.opacity = "";
//           btn.style.pointerEvents = "";

//           const span = btn.querySelector(".btn-action, .add-to-cart-text, span");
//           if (span) span.textContent = (btn.dataset.originalText || "Add to Cart");
//           else btn.textContent = (btn.dataset.originalText || "Add to Cart");
//         }
//       });
//     }

//     // --- Bail if inventory UI missing ---
//     if (!inventoryStatus || !inventoryContainer) {
//       console.warn("updateInventoryForCard: missing inventory nodes for card", card);
//       if (!variantId || !window.inventoryData) setButtonsDisabled(true);
//       return;
//     }

//     // --- No variant / no inventoryData ---
//     if (!variantId || !window.inventoryData?.inventoryMap?.[variantId]) {
//       inventoryStatus.innerHTML = `<span style="color:gray;">Keine Daten für ausgewählte Variante</span>`;
//       setButtonsDisabled(true);
//       return;
//     }

//     const variantData = window.inventoryData.inventoryMap[variantId];
//     inventoryContainer.innerHTML = "";

//     if (!variantData.inventoryLevels?.length) {
//       inventoryStatus.innerHTML = `<span style="color:gray;">Keine Lagerdaten verfügbar</span>`;
//       setButtonsDisabled(true);
//       return;
//     }

//     // compare as strings (localStorage = string)
//     const selectedLocationInventory = variantData.inventoryLevels.filter(
//       (level) => String(level.location_id) === String(selectedLocationId)
//     );

//     if (selectedLocationInventory.length === 0) {
//       inventoryStatus.innerHTML = `
//         <span style="display:inline-block; width:10px; height:10px; background-color:#f7931e; border-radius:50%; margin-right:5px;"></span>
//         <span style="color:#f7931e;">Nicht Verfügbar am gewählten Standort</span>
//       `;
//       setButtonsDisabled(true);
//       return;
//     }

//     // --- Build inventory lines ---
//     let stockAvailable = false;
//     let stockother = false;
//     let locationName = "";

//     const allLocationsWithStock = variantData.inventoryLevels.filter(l => Number(l.available_quantity) > 0);

//     selectedLocationInventory.forEach((level) => {
//       const { location_name, available_quantity } = level;
//       const stockLine = document.createElement("div");
//       stockLine.textContent = `${location_name}: ${available_quantity > 0 ? "Verfügbar" : "Wir arbeiten an Nachschub"} (${available_quantity})`;
//       inventoryContainer.appendChild(stockLine);

//       if (Number(available_quantity) > 0) {
//         stockAvailable = true;
//         locationName = location_name;
//       }
//     });

//     const otherLocationsWithStock = allLocationsWithStock.filter(
//       (l) => String(l.location_id) !== String(selectedLocationId)
//     );

//     if (!stockAvailable && otherLocationsWithStock.length > 0 && String(enabledOtherLocationMessage) === "true") {
//       stockother = true;
//     }

//     // --- Update UI & buttons ---
//     if (stockAvailable) {
//       inventoryStatus.innerHTML = `
//         <span style="font-size: 10px;">🟢</span>
//         <span style="color:#3abf62;font-size:15px;">Verfügbar in ${locationName}</span>
//       `;
//       setButtonsDisabled(false);
//       return;
//     }

//     if (stockother) {
//       inventoryStatus.innerHTML = `
//         <span style="font-size: 10px;">🟠</span>
//         <span style="color:#FFA500;font-size:15px;">An anderen Standorten verfügbar</span>
//       `;
//       setButtonsDisabled(true);
//       return;
//     }

//     inventoryStatus.innerHTML = `
//       <span style="font-size: 10px;">🔴</span>
//       <span style="color:#ff5858;font-size:15px;">Wir arbeiten an Nachschub</span>
//     `;
//     setButtonsDisabled(true);
//   } catch (err) {
//     console.error("updateInventoryForCard error:", err);
//   }
// }
//     // Load More Button logic with unique observer
//     const loadMoreBtns = document.querySelectorAll(".actions-loadmore");
//     console.log("loadMoreBtns", loadMoreBtns);
//     loadMoreBtns.forEach((loadMoreBtn) => {
//       loadMoreBtn.addEventListener("click", async function (e) {
//         const loadMoreObserver = new MutationObserver(
//           async (mutations, obs) => {
//             const addedNodes = [];
//             mutations.forEach((mutation) => {
//               mutation.addedNodes.forEach((node) => {
//                 if (
//                   node.nodeType === 1 &&
//                   node.matches(".multilocation_product-card[data-product-id]")
//                 ) {
//                   addedNodes.push(node);
//                 } else if (node.nodeType === 1 && node.querySelectorAll) {
//                   const nestedCards = node.querySelectorAll(
//                     ".multilocation_product-card[data-product-id]"
//                   );
//                   addedNodes.push(...nestedCards);
//                 }
//               });
//             });

//             if (addedNodes.length > 0) {
//               obs.disconnect();
//               await updateCollectionInventory(addedNodes);
//             }
//           }
//         );

//         const productList = document.querySelector(
//           ".product-grid, .product-list, .collection-products"
//         );
//         if (productList) {
//           loadMoreObserver.observe(productList, {
//             childList: true,
//             subtree: true,
//           });
//         }
//       });
//     });

//     let isInventoryFetchInProgress = false; // Flag to prevent multiple API calls

//     async function updateCollectionInventory() {
//       if (isInventoryFetchInProgress) {
//         console.log("Inventory fetch already in progress. Skipping...");
//         return;
//       }

//       isInventoryFetchInProgress = true; // Set the flag to true
//       const selectedLocationId = localStorage.getItem("selected_location");
//       const productCards = document.querySelectorAll(
//         ".multilocation_product-card[data-product-id]"
//       );
//       const productId = Array.from(productCards)
//         .map((card) => card.getAttribute("data-product-id"))
//         .filter(Boolean)
//         .join(",");

//       if (!productId) {
//         console.error("No product ID found.");
//         isInventoryFetchInProgress = false; // Reset the flag
//         return;
//       }

//       try {
//         const response = await fetch(
//           `https://multilocation.techspawn.net/api/get-collection-product-inventory?shopdomain=${encodeURIComponent(
//             shopdomain
//           )}&productId=${productId}`
//         );

//         if (!response.ok) {
//           console.error(
//             `Failed to fetch inventory data. Status: ${response.status}`
//           );
//           isInventoryFetchInProgress = false; // Reset the flag
//           return;
//         }

//         const data = await response.json();

//         if (!data || typeof data !== "object") {
//           console.error("Invalid data structure received from the API.");
//           isInventoryFetchInProgress = false; // Reset the flag
//           return;
//         }

//         window.inventoryData = data;

//         productCards.forEach((card) => {
//           const variantWrapper = card.querySelector(".multi_variant_id");
//           const variantId = variantWrapper?.getAttribute("data-variant-id");

//           if (!variantId || !data.inventoryMap[variantId]) {
//             console.warn(`No inventory data for variantId: ${variantId}`);
//             return;
//           }

//           updateInventoryForCard(card, variantId);
//         });
//         const allInvntoryData = await getloc_inventory_stock();
//         const pushDownOutofStockItems =
//           allInvntoryData?.settings?.pushDownOutofStockItems;
//         function getInventoryForLocation(variantId, locationId) {
//           const inventoryMap = window.inventoryData?.inventoryMap || {};
//           const variantEntry = inventoryMap[variantId];

//           if (!variantEntry || !variantEntry.inventoryLevels) return -1;

//           const level = variantEntry.inventoryLevels.find(
//             (lvl) => lvl.location_id === locationId
//           );
//           return level ? level.available_quantity : -1;
//         }

//         function sortProductsByLocationInventory() {
//           const selected_location = localStorage.getItem("selected_location");
//           if (!selected_location) {
//             console.error("[Inventory Sort] No selected_location found");
//             return;
//           }

//           // Look for all multi_variant_id elements with data-variant-id
//           const variantNodes = Array.from(
//             document.querySelectorAll(".multi_variant_id[data-variant-id]")
//           );
//           if (variantNodes.length === 0) {
//             console.error(
//               "[Inventory Sort] No .multi_variant_id with data-variant-id found"
//             );
//             return;
//           }
//           const variantDataMap = new Map();

//           for (const variantEl of variantNodes) {
//             const variantId = variantEl.dataset.variantId;
//             if (!variantId) continue;

//             const inventoryQty = getInventoryForLocation(
//               variantId,
//               selected_location
//             );

//             // Support any of these container types: li.grid__item, div.grid__item, or .product-item-sort
//             const parentItem = variantEl.closest(
//               "li.grid__item, div.grid__item, .product-item-sort"
//             );
//             if (!parentItem) {
//               console.warn(
//                 `[Inventory Sort] No matching parent container for variantId ${variantId}`
//               );
//               continue;
//             }

//             variantDataMap.set(parentItem, inventoryQty);
//           }

//           const sortedItems = [...variantDataMap.entries()]
//             .sort(([, a], [, b]) => (b || -1) - (a || -1))
//             .map(([item]) => item);

//           if (sortedItems.length > 0) {
//             const parentContainer = sortedItems[0].parentNode;
//             sortedItems.forEach((item) => parentContainer.appendChild(item));
//             console.log(
//               "[Inventory Sort] Products re-sorted by inventory at location:",
//               selected_location
//             );
//           }
//         }
//         document
//           .querySelectorAll("li.grid__item, div.grid__item, .multi_variant_id")
//           .forEach((variantWrapper) => {
//             setTimeout(() => {
//               if (
//                 pushDownOutofStockItems === true ||
//                 pushDownOutofStockItems === "true"
//               ) {
//                 sortProductsByLocationInventory();
//               }
//             }, 100);
//           });
//       } catch (error) {
//         console.error("Error fetching inventory data:", error);
//       } finally {
//         isInventoryFetchInProgress = false; // Reset the flag
//       }
//     }

//     await updateCollectionInventory();

//     document.addEventListener("updateCollectionInventory", function () {
//       const selectedLocationId = localStorage.getItem("selected_location");
//       if (selectedLocationId && isCollectionPage()) {
//         updateCollectionInventory();
//         if (
//           enabledSmartCollectionFilter === true ||
//           enabledSmartCollectionFilter === "true"
//         ) {
//           const locationshowonheader = document.getElementById(
//             "location-popup-header-id"
//           );
//           console.log("locationshowonheader_run2", locationshowonheader);
//           const locationname = locationshowonheader.textContent;
//           console.log(locationname);
//           updateFilterURL(locationname);
//           applyShopifyFilter();
//         }
//       }
//     });
//     const quantityElements = document.querySelectorAll(
//       ".quantity_showing_color"
//     );
//     quantityElements.forEach(function (quantityElement) {
//       const quantity = parseInt(quantityElement.textContent.trim());
//       if (quantity > 10) {
//         quantityElement.classList.add("stock-green");
//       } else if (quantity > 0) {
//         quantityElement.classList.add("stock-yellow");
//       } else {
//         quantityElement.classList.add("stock-red");
//       }
//     });
//   }

// setInterval(() => {
//   const elements = document.querySelectorAll(".location-card-drawer-list-view-address");
 
//   elements.forEach(elem => {
//     if (!elem.dataset.modified) {
//       const lines = elem.innerHTML.split("<br>");
//         // console.log("lines",lines.length);
//       if(lines.length == 4){
//         const line1 = lines[0] ? lines[0].trim() : "";
//         const line2 = lines[1] ? lines[1].trim() : "";
//         elem.textContent = `${line1}`;
//         elem.dataset.modified = "true";
//       } else if(lines.length == 5){
//         const line1 = lines[0] ? lines[0].trim() : "";
//         const line2 = lines[1] ? lines[1].trim() : "";
//         elem.textContent = `${line1} ${line2}`; 
//         elem.dataset.modified = "true";
//       }
//     }
//   });
// }, 500); 
 
  

// });


document.addEventListener("DOMContentLoaded", async function () {
  if (typeof window.Shopify !== "undefined" && window.Shopify.routes) {
    // Prevent multiple initializations
    if (window.multiLocationInitialized) {
      return;
    }
    window.multiLocationInitialized = true;
    
    const shopdomain = Shopify.shop || window.location.hostname;
    const locale = window.Shopify.locale;
    const market = document.getElementById('market-id').value ?? '';

    // Preload inventory data immediately
    const preloadPromise = new Promise(async (resolve) => {
      try {
        const data = await getloc_inventory_stock();
        resolve(data);
      } catch (e) {
        resolve(null);
      }
    });

    function setInventoryData(key, value) {
      // Double encoding to handle HTML content with attributes that can break JSON
      const setdata = encodeURIComponent(JSON.stringify(value));
      const expiryDate = new Date();
      expiryDate.setHours(expiryDate.getHours() + 24); // 24 hours cache
      document.cookie = `${key}_${market}=${setdata}; expires=${expiryDate.toUTCString()}; path=/`;
      
      // Also store in localStorage for faster access
      try {
        localStorage.setItem(`${key}_${market}`, setdata);
        localStorage.setItem(`${key}_${market}_timestamp`, Date.now().toString());
      } catch (e) {
        console.warn('localStorage full, using cookies only');
      }
    }

    function getInventoryData(key) {
      // Try localStorage first (faster than cookies)
      try {
        const timestamp = localStorage.getItem(`${key}_${market}_timestamp`);
        if (timestamp) {
          const age = Date.now() - parseInt(timestamp);
          const maxAge = 24 * 60 * 60 * 1000; // 24 hours in milliseconds
          
          if (age < maxAge) {
            const data = localStorage.getItem(`${key}_${market}`);
            if (data) return data;
          } else {
            // Clean up expired localStorage data
            localStorage.removeItem(`${key}_${market}`);
            localStorage.removeItem(`${key}_${market}_timestamp`);
          }
        }
      } catch (e) {
        console.warn('localStorage access failed, falling back to cookies');
      }
      
      // Fallback to cookies
      const cookies = document.cookie.split("; ");
      for (let cookie of cookies) {
        const [ckey, value] = cookie.split("=");
        if (ckey === `${key}_${market}`) return value;
      }
      return null;
    }

    // Global cache for inventory data to prevent multiple API calls
    let globalInventoryDataCache = null;
    let isInventoryDataFetching = false;

    // Function to clear global cache
    function clearInventoryCache() {
      globalInventoryDataCache = null;
      isInventoryDataFetching = false;
    }

    // Service worker removed due to CORS issues
    // Using localStorage and memory cache instead

    // Clear selected location when market changes
    const currentMarket = localStorage.getItem('current_market');
    if (currentMarket !== market) {
      localStorage.removeItem('selected_location');
      localStorage.setItem('current_market', market);
      // Clear global cache when market changes
      clearInventoryCache();
      // Clear localStorage cache
      Object.keys(localStorage).forEach(key => {
        if (key.includes('allInvntoryData')) {
          localStorage.removeItem(key);
        }
      });
    }

    const getloc_inventory_stock = async () => {
      // Return cached data immediately if available (< 1ms response)
      if (globalInventoryDataCache) {
        console.log('🚀 Ultra-fast cache hit: < 1ms');
        return globalInventoryDataCache;
      }

      // If already fetching, wait for the ongoing request
      if (isInventoryDataFetching) {
        console.log('⏳ Waiting for ongoing request...');
        return new Promise((resolve) => {
          const checkCache = setInterval(() => {
            if (globalInventoryDataCache && !isInventoryDataFetching) {
              clearInterval(checkCache);
              console.log('✅ Got data from ongoing request');
              resolve(globalInventoryDataCache);
            }
          }, 10); // Check every 10ms instead of 100ms
        });
      }

      // Check cookie cache first
      const cached = getInventoryData("allInvntoryData");
      if (cached) {
        try {
          const recivieddata = JSON.parse(decodeURIComponent(cached));
          // Validate the cached data structure
          if (recivieddata && recivieddata.settings) {
            console.log('📦 Using valid cached data');
            globalInventoryDataCache = recivieddata;
            return recivieddata;
          } else {
            console.warn('Cached data is invalid, fetching fresh');
          }
        } catch (e) {
          console.error("Error parsing cached data:", e);
          // Clear corrupted cache
          try {
            localStorage.removeItem(`allInvntoryData_${market}`);
            localStorage.removeItem(`allInvntoryData_${market}_timestamp`);
          } catch (cleanupError) {
            console.warn('Cache cleanup failed:', cleanupError);
          }
        }
      }

      // Add DNS prefetch and preconnect for faster requests
      if (!document.querySelector('link[href*="multilocation.techspawn.net"]')) {
        const prefetchLink = document.createElement('link');
        prefetchLink.rel = 'dns-prefetch';
        prefetchLink.href = 'https://multilocation.techspawn.net';
        document.head.appendChild(prefetchLink);
        
        const preconnectLink = document.createElement('link');
        preconnectLink.rel = 'preconnect';
        preconnectLink.href = 'https://multilocation.techspawn.net';
        document.head.appendChild(preconnectLink);
      }

      // Set fetching flag
      isInventoryDataFetching = true;

      try {
        var variant_id = 0;
        var fromgeoblock = true;
        var product_id = 0;
        const url = `https://multilocation.techspawn.net/api/get-loc-inventory-stock?shopdomain=${encodeURIComponent(
          shopdomain
        )}&variant_id=${encodeURIComponent(
          variant_id
        )}&locale=${encodeURIComponent(
          locale
        )}&fromgeoblock=${encodeURIComponent(
          fromgeoblock
        )}&product_id=${encodeURIComponent(product_id)}&market=${encodeURIComponent(market)}`;
        
        // Simple fetch with timeout and retry logic
        const controller = new AbortController();
        const timeoutId = setTimeout(() => controller.abort(), 10000); // 10 second timeout
        
        let result;
        for (let attempt = 1; attempt <= 2; attempt++) {
          try {
            // First try with minimal headers to avoid CORS issues
            result = await fetch(url, {
              method: "GET",
              signal: controller.signal
            });
            
            clearTimeout(timeoutId);
            break;
          } catch (fetchError) {
            console.warn(`Attempt ${attempt} failed:`, fetchError.message);
            if (attempt === 2) throw fetchError;
            await new Promise(resolve => setTimeout(resolve, 1000)); // 1 second delay
          }
        }
        
        if (!result.ok) {
          throw new Error(`HTTP error! Status: ${result.status}`);
        }
        
        const data = await result.json();
        
        // Cache the data globally and in cookies
        globalInventoryDataCache = data;
        setInventoryData("allInvntoryData", data);
        
        // Schedule background refresh after 20 minutes
        setTimeout(() => {
          globalInventoryDataCache = null;
          getloc_inventory_stock().catch(() => {}); // Silent background refresh
        }, 20 * 60 * 1000);
        
        if (!window.mobileViewLogged) {
          console.log("✅ Desktop-js - API Connected Successfully ⚡");
          window.mobileViewLogged = true;
        }
        
        return data;
      } catch (error) {
        console.error("API fetch failed:", error);
        
        // Return a minimal fallback structure to prevent crashes
        const fallbackData = {
          settings: {
            locations_arr: [],
            headerBlock: "false",
            enabledSmartCollectionFilter: false,
            enabledOtherLocationMessage: false,
            otherLocationMessage: "Service temporarily unavailable"
          }
        };
        
        // Cache the fallback to prevent repeated failed requests
        globalInventoryDataCache = fallbackData;
        
        return fallbackData;
      } finally {
        isInventoryDataFetching = false;
      }
    };

    // Add a function to observe DOM changes and detect when an element is added
    function waitForElement(selector, callback) {
      // Check if element already exists
      const element = document.querySelector(selector);
      if (element) {
        callback(element);
        return;
      }

      // If not, set up a mutation observer to watch for it
      const observer = new MutationObserver((mutations) => {
        const element = document.querySelector(selector);
        if (element) {
          observer.disconnect();
          callback(element);
        }
      });

      // Start observing the document with the configured parameters
      observer.observe(document.body, {
        childList: true,
        subtree: true,
      });
    }

    function haversineDistance(lat1, lon1, lat2, lon2, distanceIN) {
      const toRadians = (degrees) => degrees * (Math.PI / 180);
      const R = 6371;
      const dLat = toRadians(lat2 - lat1);
      const dLon = toRadians(lon2 - lon1);
      const a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(toRadians(lat1)) *
          Math.cos(toRadians(lat2)) *
          Math.sin(dLon / 2) *
          Math.sin(dLon / 2);
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      let distance = R * c;
      if (distanceIN === "false") {
        distance *= 0.621371;
      }
      return distance;
    }

    var enabledSmartCollectionFilter = false;
    let otherLocationMessage = "✔ Available in other locations";
    let enabledOtherLocationMessage = false;
    const display_location_stock = async (variant_id, baseUrl) => {
      const allInvntoryData = await getloc_inventory_stock();
      
      // Handle null or invalid response
      if (!allInvntoryData || !allInvntoryData.settings) {
        console.warn('No inventory data available, using fallback settings');
        // Use fallback/default behavior when API fails
        return;
      }
      
      const invntorydata = allInvntoryData?.settings;
      otherLocationMessage =
        invntorydata?.otherLocationMessage ?? otherLocationMessage;
      enabledOtherLocationMessage =
        invntorydata?.enabledOtherLocationMessage ?? false;

      const locationPopup = invntorydata?.locationPopup;
      const locationPopupstyle = invntorydata?.locationPopupstyle;
      // const locationSelectionType = invntorydata?.locationSelectionType;
      const locationPopupHeader = invntorydata?.locationPopupHeader;
      const locationPopupDescription = invntorydata?.locationPopupDescription;
      // const locationarr = allInvntoryData?.settings?.locations_arr;
      var locationarr = allInvntoryData.settings.locations_arr;
      const locationSelectionType =
        allInvntoryData.settings.locationSelectionType;
      const headerBlock = allInvntoryData?.settings?.headerBlock;
      const headerBlockstyle = allInvntoryData?.settings?.headerBlockstyle;
      const enableGeolocationSearch =
        invntorydata?.locationFilterSetting?.enableGeolocationSearch ?? "false";
      const google_map_api_key =
        invntorydata?.locationFilterSetting?.google_api_key ?? "";
      const distanceIN = invntorydata?.distanceIN;
      enabledSmartCollectionFilter =
        allInvntoryData?.settings?.enabledSmartCollectionFilter;

      function isFilterApplied() {
        const urlParams = new URLSearchParams(window.location.search);
        // Check for specific filter parameters in the URL
        return (
          urlParams.has("filter.p.tag") &&
          urlParams.has("filter.v.m.multilocation_app.inventory_location")
        );
      }
      window.locationPopupData = {
        locationPopup,
        locationPopupstyle,
        locationSelectionType,
        locationPopupHeader,
        locationPopupDescription,
        locationarr,
      };

      const locationNamesDropDown = document.getElementById(
        "locationNamesDropDown"
      );
      const conatinerforall = document.createElement("div");
      const locationNamesDropDownselect = document.createElement("select");
      if (locationNamesDropDown && headerBlock === "true") {
        locationNamesDropDown.innerHTML = "";
        const loctionstore_icon = `<svg viewBox="0 0 24 24" focusable="false" width="35" height="30" aria-hidden="true" class="hnf-svg-icon"><path fill-rule="evenodd" clip-rule="evenodd" d="M2 4v16h20V4H2zm2 4V6h16v2H4zm0 2v8h3v-6h10v6h3v-8H4zm11 4h-2v4h2v-4zm-4 0H9v4h2v-4z"></path></svg>`;
        locationNamesDropDown.insertAdjacentHTML(
          "beforeend",
          loctionstore_icon
        );
        const locations_arr = allInvntoryData.settings.locations_arr;

        if (headerBlockstyle === "dropdown") {
          locationNamesDropDownselect.id = "locationNamesDropDownselect";
          locationNamesDropDownselect.name = "selected_location";
          locationNamesDropDownselect.classList.add("location-dropdown");
          const option = document.createElement("option");
          option.value = "";
          option.textContent = "Wähle deinen Standort";
          locationNamesDropDownselect.appendChild(option);
          for (const location of locations_arr) {
            const option = document.createElement("option");
            option.value = location.node.id.split("/").pop();
            option.textContent = location.node.name;
            locationNamesDropDownselect.appendChild(option);
          }
          locationNamesDropDown.appendChild(locationNamesDropDownselect);

          // Sync dropdown selection with radio button selection
          locationNamesDropDownselect.addEventListener("change", function () {
            const selectedLocationId = locationNamesDropDownselect.value;

            // Save the selected location to LocalStorage
            localStorage.setItem("selected_location", selectedLocationId);

            // Find the radio button that matches the selected location
            const matchingRadioButton = document.querySelector(
              `input[name="selected_location"][value="${selectedLocationId}"]`
            );

            if (matchingRadioButton) {
              matchingRadioButton.checked = true;
              if (locationSelectionType === "colorinversion") {
                const locationCard = matchingRadioButton.closest(
                  ".location-card-listview"
                );
                if (locationCard) {
                  // First remove any existing styles from all cards
                  const allLocationCards = document.querySelectorAll(
                    ".location-card-listview"
                  );
                  allLocationCards.forEach((card) => {
                    card.style.removeProperty("background-color");
                    card.style.removeProperty("color");
                  });
                  // Then set the styles for the selected card
                  locationCard.style.backgroundColor =
                    "rgb(var(--color-foreground))";
                  locationCard.style.color = "rgb(var(--color-background))";
                }
              }
            }
            setTimeout(() => updateCollectionInventory(), 50);
          });
        }

        if (headerBlockstyle === "popup") {
          const locationshowonheader = document.createElement("div");
          locationshowonheader.classList.add("location-popup-header");
          locationshowonheader.id = "location-popup-header-id";
          const savelocationid = localStorage.getItem("selected_location");
          if (
            savelocationid == null ||
            savelocationid == undefined ||
            savelocationid == "undefined" ||
            savelocationid == ""
          ) {
            locationshowonheader.textContent = "Wähle deinen Standort";
          } else {
            for (const location of locations_arr) {
              if (location.node.id.split("/").pop() == savelocationid) {
                locationshowonheader.textContent = location.node.name;
              }
            }
          }
          locationNamesDropDown.appendChild(locationshowonheader);
          locationshowonheader.addEventListener("click", function () {
            document.dispatchEvent(new CustomEvent("openLocationPopup"));
          });
        }

        if (headerBlockstyle === "drawer") {
          // console.log("headerBlockstyle", headerBlockstyle);

          const locationshowonheader = document.createElement("div");
          locationshowonheader.classList.add("location-popup-header");
          locationshowonheader.id = "location-popup-header-id";
          // console.log("locationshowonheader_run3", locationshowonheader);
          const savelocationid = localStorage.getItem("selected_location");
          if (
            savelocationid == null ||
            savelocationid == undefined ||
            savelocationid == "undefined" ||
            savelocationid == ""
          ) {
            locationshowonheader.textContent = "Wähle deinen Standort";
          } else {
            for (const location of locations_arr) {
              if (location.node.id.split("/").pop() == savelocationid) {
                locationshowonheader.textContent = location.node.name;
              }
            }
          }
          locationNamesDropDown.appendChild(locationshowonheader);
          locationshowonheader.addEventListener("click", function () {
            console.log("run");
            const savelocationid = localStorage.getItem("selected_location");
            console.log(savelocationid, "savelocationid_run");
            const drawerOverlay = document.createElement("div");
            drawerOverlay.id = "inventoryDrawerOverlay";
            drawerOverlay.classList.add("multiloca-inventory-drawer-overlay");
              drawerOverlay.addEventListener("click", function (event) {
                if (event.target === drawerOverlay) {
                    drawerContent.style.animation =
                        ".2s ease-out slidedown-location-drawer";
                    setTimeout(() => {
                        document.body.removeChild(drawerOverlay);
                    }, 200);
                }
            });
            const drawerContent = document.createElement("div");
            drawerContent.id = "inventoryDrawerContent";
            drawerContent.classList.add("multiloca-inventory-drawer-content");
            drawerContent.style.animation =
              ".4s ease-out slideup-location-drawer";

            const drawerHeader = document.createElement("div");
            drawerHeader.id = "inventoryDrawerHeader";
            drawerHeader.classList.add("custom_drawer__header");

            const drawerTitle = document.createElement("h2");
            drawerTitle.id = "inventoryDrawerTitle";
            drawerTitle.classList.add("multiloca-inventory-drawer-title");
            drawerTitle.textContent = "Wähle deinen Standort";
            drawerHeader.appendChild(drawerTitle);
            drawerContent.appendChild(drawerHeader);

            const closeButton = document.createElement("button");
            closeButton.id = "closeDrawerButton";
            closeButton.classList.add("multiloca-close-drawer-button");
            closeButton.textContent = "X";
            closeButton.addEventListener("click", function () {
              drawerContent.style.animation =
                ".2s ease-out slidedown-location-drawer";
              setTimeout(() => {
                document.body.removeChild(drawerOverlay);
              }, 200);
            });
            drawerContent.appendChild(closeButton);

            const locationsContainer = document.createElement("div");
            locationsContainer.id = "drawerLocationsContainer";
            locationsContainer.style.backgroundColor = "#f5f5f5";
            drawerContent.appendChild(locationsContainer);

            //geolocation code
            const geolocationSearch = document.createElement("div");
            const geolocationSearchInput = document.createElement("input");
            const usemylocation = document.createElement("a");
            const searchIcon = document.createElement("span");
            const predictionlocationNames = [];
            if (enableGeolocationSearch == "true" && google_map_api_key != "") {
              const googlePlacesScript = document.createElement("script");
              googlePlacesScript.src = `https://maps.googleapis.com/maps/api/js?key=${google_map_api_key}&libraries=places`;
              document.head.appendChild(googlePlacesScript);
              geolocationSearch.classList.add("geolocation-search");
              geolocationSearchInput.type = "text";
              geolocationSearchInput.placeholder =
                "Enter address, zip code or city";
              geolocationSearchInput.classList.add("geolocation-search-input");
              searchIcon.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 96 960 960" width="20"><path d="M796 876 590 670q-34 29-72.5 44t-82.5 15q-108 0-183.5-75.5T176 470q0-108 75.5-183.5T435 211q108 0 183.5 75.5T694 470q0 45-14 85t-44 75l207 207q9 9 9 21t-9 21l-29 29q-9 9-21 9t-21-9ZM436 674q75 0 127.5-52.5T616 470q0-75-52.5-127.5T436 290q-75 0-127.5 52.5T256 470q0 75 52.5 127.5T436 674Z"/></svg>`;
              searchIcon.classList.add("search-icon");
              usemylocation.innerHTML = `
                                        <svg viewBox="0 0 24 24" focusable="false" width="24" height="24" aria-hidden="true" class="hnf-svg-icon hnf-btn__icon"><path d="M12 15c1.6569 0 3-1.3431 3-3s-1.3431-3-3-3-3 1.3431-3 3 1.3431 3 3 3z"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M18.9205 13H21v-2h-2.0795A6.9929 6.9929 0 0 0 13 5.08V3h-2v2.08A6.9928 6.9928 0 0 0 5.08 11H3v2h2.08A6.9924 6.9924 0 0 0 11 18.9205V21h2v-2.0795A6.9927 6.9927 0 0 0 18.9205 13zm-2.7632-3.7779A4.9993 4.9993 0 0 1 17 12a5.006 5.006 0 0 1-1.4661 3.5339A5.006 5.006 0 0 1 12 17a5 5 0 1 1 4.1573-7.7779z"></path></svg>`;
              usemylocation.classList.add("use-my-location");
              usemylocation.href = "#";
              usemylocation.addEventListener("click", async (e) => {
                e.preventDefault();
                try {
                  const position = await new Promise((resolve, reject) => {
                    navigator.geolocation.getCurrentPosition(resolve, reject);
                  });
                  cust_lat = position.coords.latitude;
                  cust_lng = position.coords.longitude;
                  geolocationSearchInput.value = "";
                  const detailsUrl = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${cust_lat},${cust_lng}&key=${google_map_api_key}`;
                  fetch(detailsUrl)
                    .then((response) => response.json())
                    .then((details) => {
                      if (details.results && details.results.length > 0) {
                        const components =
                          details.results[0].address_components;
                        const address = components.find((component) =>
                          component.types.includes("street_number")
                        );
                        const city = components.find((component) =>
                          component.types.includes("locality")
                        );
                        const state = components.find((component) =>
                          component.types.includes(
                            "administrative_area_level_1"
                          )
                        );
                        const zip = components.find((component) =>
                          component.types.includes("postal_code")
                        );
                        const country = components.find((component) =>
                          component.types.includes("country")
                        );
                        geolocationSearchInput.value = `${
                          address ? address.long_name : ""
                        } ${city ? city.long_name : ""} ${
                          state ? state.long_name : ""
                        } ${zip ? zip.long_name : ""} ${
                          country ? country.long_name : ""
                        }`;

                        locations_arr.forEach((loc) => {
                          var corrdiloc =
                            loc.node.address.latitude +
                            "," +
                            loc.node.address.longitude;
                          let locCoords = corrdiloc ? corrdiloc.split(",") : [];
                          locCoords[0] = parseFloat(locCoords[0]);
                          locCoords[1] = parseFloat(locCoords[1]);
                          loc.distance = haversineDistance(
                            cust_lat,
                            cust_lng,
                            locCoords[0],
                            locCoords[1],
                            distanceIN
                          );
                          if (Number.isNaN(loc.distance)) {
                            loc.distance = "-";
                          }
                        });
                        locations_arr.sort((a, b) => {
                          if (a.distance === "-" && b.distance === "-")
                            return 0;
                          if (a.distance === "-") return 1;
                          if (b.distance === "-") return -1;
                          return a.distance - b.distance;
                        });
                        showfilrterdlocations(locations_arr);
                      }
                    })
                    .catch((error) => {
                      console.error("Error fetching place details:", error);
                    });
                } catch (error) {
                  console.error(error);
                }
              });
              console.log(locations_arr);
              geolocationSearch.appendChild(searchIcon);
              geolocationSearch.appendChild(geolocationSearchInput);
              geolocationSearch.appendChild(usemylocation);

              locationsContainer.appendChild(geolocationSearch);
              // locationsContainer.appendChild(usemylocation);
              const a = document.createElement("div");
              a.classList.add("autocomplete-items");
              geolocationSearch.appendChild(a);

              let addalready = false;
              geolocationSearchInput.addEventListener(
                "input",
                function (event) {
                  const searchValue = event.target.value;

                  if (addalready == false) {
                    addalready = true;
                    usemylocation.innerHTML = searchIcon.innerHTML;
                  }
                  searchIcon.innerHTML = "";

                  if (searchValue === "") {
                    addalready = false;
                    searchIcon.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 96 960 960" width="20"><path d="M796 876 590 670q-34 29-72.5 44t-82.5 15q-108 0-183.5-75.5T176 470q0-108 75.5-183.5T435 211q108 0 183.5 75.5T694 470q0 45-14 85t-44 75l207 207q9 9 9 21t-9 21l-29 29q-9 9-21 9t-21-9ZM436 674q75 0 127.5-52.5T616 470q0-75-52.5-127.5T436 290q-75 0-127.5 52.5T256 470q0 75 52.5 127.5T436 674Z"/></svg>`;
                    usemylocation.innerHTML = `<svg viewBox="0 0 24 24" focusable="false" width="24" height="24" aria-hidden="true" class="hnf-svg-icon hnf-btn__icon"><path d="M12 15c1.6569 0 3-1.3431 3-3s-1.3431-3-3-3-3 1.3431-3 3 1.3431 3 3 3z"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M18.9205 13H21v-2h-2.0795A6.9929 6.9929 0 0 0 13 5.08V3h-2v2.08A6.9928 6.9928 0 0 0 5.08 11H3v2h2.08A6.9924 6.9924 0 0 0 11 18.9205V21h2v-2.0795A6.9927 6.9927 0 0 0 18.9205 13zm-2.7632-3.7779A4.9993 4.9993 0 0 1 17 12a5.006 5.006 0 0 1-1.4661 3.5339A5.006 5.006 0 0 1 12 17a5 5 0 1 1 4.1573-7.7779z"></path></svg>`;
                    a.innerHTML = "";
                    return;
                  }

                  const autocompleteService =
                    new google.maps.places.AutocompleteService();

                  autocompleteService.getPlacePredictions(
                    { input: searchValue },
                    (predictions, status) => {
                      if (
                        status === google.maps.places.PlacesServiceStatus.OK
                      ) {
                        predictions.forEach((prediction) => {
                          predictionlocationNames.push({
                            description: prediction.description,
                            placeId: prediction.place_id,
                          });
                        });
                      } else {
                        console.error("Error fetching predictions:", status);
                      }
                    }
                  );

                  a.innerHTML = "";
                  var loc_lat;
                  var loc_lng;
                  const filteredNames = predictionlocationNames.filter((n) =>
                    n.description
                      .toLowerCase()
                      .includes(searchValue.toLowerCase())
                  );
                  filteredNames.slice(0, 5).forEach((name) => {
                    let uniqueId = `placeId-${Math.random()
                      .toString(36)
                      .substr(2, 9)}`;
                    const b = document.createElement("div");
                    b.innerHTML =
                      "<strong>" +
                      name.description.substr(0, searchValue.length) +
                      "</strong>";
                    b.innerHTML += name.description.substr(searchValue.length);
                    b.innerHTML +=
                      "<input type='hidden' value='" + name.description + "'>";
                    b.innerHTML += `<input type='hidden' value='${name.placeId}' id='${uniqueId}'>`;
                    b.addEventListener("click", function (e) {
                      const selectedPlaceId =
                        document.getElementById(uniqueId).value;
                      geolocationSearchInput.value =
                        this.getElementsByTagName("input")[0].value;
                      const detailsUrl = `https://maps.googleapis.com/maps/api/place/details/json?place_id=${selectedPlaceId}&key=${google_map_api_key}`;
                      fetch(detailsUrl)
                        .then((response) => response.json())
                        .then((details) => {
                          if (details.result.geometry) {
                            loc_lat = details.result.geometry.location.lat;
                            loc_lng = details.result.geometry.location.lng;

                            locations_arr.forEach((loc) => {
                              var corrdiloc =
                                loc.node.address.latitude +
                                "," +
                                loc.node.address.longitude;
                              let locCoords = corrdiloc
                                ? corrdiloc.split(",")
                                : [];
                              locCoords[0] = parseFloat(locCoords[0]);
                              locCoords[1] = parseFloat(locCoords[1]);
                              loc.distance = haversineDistance(
                                loc_lat,
                                loc_lng,
                                locCoords[0],
                                locCoords[1]
                              );
                              if (Number.isNaN(loc.distance)) {
                                loc.distance = "-";
                              }
                            });
                            locations_arr.sort((a, b) => {
                              if (a.distance === "-" && b.distance === "-")
                                return 0;
                              if (a.distance === "-") return 1;
                              if (b.distance === "-") return -1;
                              return a.distance - b.distance;
                            });
                            showfilrterdlocations(locations_arr);
                          } else {
                            console.error(
                              "No geometry data available for this place."
                            );
                          }
                        })
                        .catch((error) => {
                          console.error("Error fetching place details:", error);
                        });
                      a.innerHTML = "";
                    });
                    a.appendChild(b);
                  });
                }
              );
            }

            showfilrterdlocations(locations_arr);
            function showfilrterdlocations(locations_arr) {
              //clear all location card from locationsContainer
              const locationcontainer = document.querySelectorAll(
                ".locationCardDrawerView"
              );
              if (locationcontainer) {
                locationcontainer.forEach((loc) => {
                  loc.remove();
                });
              }
              for (const location of locations_arr) {
                const locationCard = document.createElement("div");
                locationCard.classList.add("locationCardDrawerView");
                if (location.node.id.split("/").pop() == savelocationid) {
                  locationCard.classList.add(
                    "location-card-drawer-list-view-selected"
                  );
                } else {
                  locationCard.classList.add("location-card-drawer-list-view");
                }
                locationCard.setAttribute(
                  "data-location-id",
                  location.node.id.split("/").pop()
                );

                const locationNameshow = document.createElement("div");
                locationNameshow.classList.add(
                  "location-card-drawer-list-view-name"
                );
                locationNameshow.textContent = location.node.name;
                locationCard.appendChild(locationNameshow);

                const locationAddress = document.createElement("div");
                locationAddress.classList.add(
                  "location-card-drawer-list-view-address"
                );
                for (const address of location.node.address.formatted) {
                  locationAddress.innerHTML += address + "<br />";
                }
                locationCard.appendChild(locationAddress);
                locationsContainer.appendChild(locationCard);

                locationCard.addEventListener("click", function () {
                  const selectedLocationId =
                    locationCard.getAttribute("data-location-id");
                  localStorage.setItem("selected_location", selectedLocationId);
                  setTimeout(() => {
                    // Remove the selected class from all location cards
                    const allLocationCards = document.querySelectorAll(
                      ".location-card-drawer-list-view-selected"
                    );
                    console.log(allLocationCards);
                    allLocationCards.forEach((card) => {
                      console.log(card);
                      card.classList.remove(
                        "location-card-drawer-list-view-selected"
                      );
                      card.classList.add("location-card-drawer-list-view");
                    });
                    console.log(locationCard);
                    // Add the selected class to the clicked card
                    locationCard.classList.remove(
                      "location-card-drawer-list-view"
                    );
                    locationCard.classList.add(
                      "location-card-drawer-list-view-selected"
                    );
                    locationCard.dataset.selected = true;

                    // Update the header location name
                    locationshowonheader.textContent = location.node.name;

                    // Close the drawer
                    document.body.removeChild(drawerOverlay);
                  }, 50); // Delay of 50ms
                  // Trigger change event for the dropdown with delay
                  setTimeout(() => updateCollectionInventory(), 50);

                  if (
                    enabledSmartCollectionFilter === true ||
                    enabledSmartCollectionFilter === "true"
                  ) {
                    if (window.location.pathname.includes("/collections/")) {
                      updateFilterURL(location.node.name);
                      applyShopifyFilter();
                    }
                  }

                  // const event = new Event('change', { bubbles: true });
                  // locationNamesDropDownselect.dispatchEvent(event);

                  // Call showlocations function if it's accessible
                  if (window.multiLocationShowLocations) {
                    window.multiLocationShowLocations(selectedLocationId);
                  }
                });
              }
            }

            // Append the drawer content to the overlay
            drawerOverlay.appendChild(drawerContent);

            // Append the overlay to the body
            document.body.appendChild(drawerOverlay);
          });
        }

        // After appending the dropdown to the DOM

        // Initial load with delay to ensure DOM is ready
        setTimeout(() => updateCollectionInventory(), 200);
        
        locationNamesDropDownselect.addEventListener("change", function () {
          const selectedLocationId = locationNamesDropDownselect.value;
          localStorage.setItem("selected_location", selectedLocationId);

          // Get all product pages' radio buttons that match the selected location
          const matchingRadioButtons = document.querySelectorAll(
            `input[name="selected_location"][value="${selectedLocationId}"]`
          );
          matchingRadioButtons.forEach((radio) => {
            radio.checked = true;

            // Dispatch a custom click event to ensure any associated event handlers run
            const clickEvent = new Event("change", { bubbles: true });
            radio.dispatchEvent(clickEvent);

            // Apply styling if needed
            if (locationSelectionType === "colorinversion") {
              const locationCard = radio.closest(".location-card-listview");
              if (locationCard) {
                // Reset all cards
                const allLocationCards = document.querySelectorAll(
                  ".location-card-listview"
                );
                allLocationCards.forEach((card) => {
                  card.style.removeProperty("background-color");
                  card.style.removeProperty("color");
                });
                // Style the selected card
                locationCard.style.backgroundColor =
                  "rgb(var(--color-foreground))";
                locationCard.style.color = "rgb(var(--color-background))";
              }
            }
          });

          // Call showlocations function if it's accessible
          if (window.multiLocationShowLocations) {
            window.multiLocationShowLocations(selectedLocationId);
          }

          console.log("Location changed to:", selectedLocationId);
        });
      } else {
        locationNamesDropDown.innerHTML = "";
      }

      const savedLocationId = localStorage.getItem("selected_location");
      if (savedLocationId) {
        locationNamesDropDownselect.value = savedLocationId;
      }
    };

    // Wait for the header location dropdown to be added to the DOM
    waitForElement("#locationNamesDropDownselect", (headerLocationDropdown) => {
      headerLocationDropdown.addEventListener("change", function () {
        const selectedLocationId = headerLocationDropdown.value;
        localStorage.setItem("selected_location", selectedLocationId);
        console.log("Header location changed to:", selectedLocationId);

        // Dispatch a custom event that other scripts can listen for
        const event = new CustomEvent("locationChanged", {
          detail: { locationId: selectedLocationId },
        });
        document.dispatchEvent(event);
        setTimeout(() => updateCollectionInventory(), 50);
      });
    });

    // Wait for preload to complete before initializing
    preloadPromise.then(() => {
      console.log('🚀 Inventory data preloaded and ready!');
    });
    
    display_location_stock();

    // Header block base locations collection filter
    function attachDropdownListener(locationDropdown) {
      locationDropdown.addEventListener("change", function () {
        let selectedOption =
          locationDropdown.options[locationDropdown.selectedIndex];
        let selectedLocation = selectedOption
          ? selectedOption.textContent.trim()
          : null;
        if (selectedLocation) {
          let filterCheckboxes = document.querySelectorAll(
            'input[type="checkbox"]'
          );
          let locationMatched = false;
          filterCheckboxes.forEach((checkbox) => {
            let label = checkbox.closest("label");
            let labelText = label ? label.textContent.trim() : "";
            if (labelText.includes(selectedLocation)) {
              checkbox.checked = true;
              locationMatched = true;
            } else {
              checkbox.checked = false;
            }
          });

          if (locationMatched) {
            updateFilterURL(selectedLocation);
            applyShopifyFilter();
          } else {
            console.warn("No matching checkbox found for:", selectedLocation);
          }
        }
      });
    }

    function isCollectionPage() {
      // Check if the current URL contains "/collections/"
      return window.location.pathname.includes("/collections/");
    }

    // function updateFilterURL(location) {
    //   if (!isCollectionPage()) {
    //     console.log(
    //       "Filter not applied: Current page is not a collection page."
    //     );
    //     return;
    //   }

    //   let currentURL = new URL(window.location.href);
    //   currentURL.searchParams.set("filter.p.tag", location);
    //   currentURL.searchParams.set(
    //     "filter.v.m.multilocation_app.inventory_location",
    //     location
    //   );
    //   window.history.pushState({}, "", currentURL.toString());
    //   applyShopifyFilter();
    // }
    function updateFilterURL(location) {
      let currentURL = new URL(window.location.href);
      currentURL.searchParams.set("filter.p.tag", location);
      currentURL.searchParams.set(
        "filter.v.m.multilocation_app.inventory_location",
        location
      );
      window.history.pushState({}, "", currentURL.toString());
      applyShopifyFilter();
    }
    function applyShopifyFilter() {
      if (
        window.Shopify &&
        window.Shopify.theme &&
        window.Shopify.theme.handleFilters
      ) {
        window.Shopify.theme.handleFilters();
      } else {
        location.reload();
      }
    }

    function handleDrawerLocationSelection(locationCard, locationName) {
      const selectedLocationId = locationCard.getAttribute("data-location-id");

      // Save the selected location to LocalStorage
      localStorage.setItem("selected_location", selectedLocationId);

      // Update the header location name
      const locationshowonheader = document.getElementById(
        "location-popup-header-id"
      );

      console.log("locationshowonheader_run", locationshowonheader);
      if (locationshowonheader) {
        locationshowonheader.textContent = locationName;
      }

      // Apply the filter dynamically
      console.log("Applying filter for drawer location:", locationName);
      updateFilterURL(locationName);
      applyShopifyFilter();

      // Dispatch a custom event to notify other parts of the app
      const event = new CustomEvent("locationChanged", {
        detail: { locationId: selectedLocationId },
      });
      document.dispatchEvent(event);
    }

    const observer = new MutationObserver(() => {
      let locationDropdown = document.getElementById(
        "locationNamesDropDownselect"
      );
      if (locationDropdown) {
        observer.disconnect();
        if (
          enabledSmartCollectionFilter === true ||
          enabledSmartCollectionFilter === "true"
        ) {
          attachDropdownListener(locationDropdown);
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });

    document.querySelectorAll("variant-radios").forEach((variantRadio) => {
      const variantDataScript = variantRadio.querySelector(
        'script[type="application/json"]'
      );
      if (!variantDataScript) return;

      const variantData = JSON.parse(variantDataScript.textContent);
      const radioInputs = variantRadio.querySelectorAll('input[type="radio"]');

      radioInputs.forEach((input) => {
        input.addEventListener("change", () => {
          const selectedOptionValue = input.value;
          const matchingVariant = variantData.find(
            (variant) => variant.title === selectedOptionValue
          );

          if (!matchingVariant) {
            console.warn(
              "No matching variant found for selected option:",
              selectedOptionValue
            );
            return;
          }

          const selectedVariantId = matchingVariant.id;
          const productId = variantRadio.getAttribute("data-product");

          const card = document.querySelector(
            `.multilocation_product-card[data-product-id="${productId}"]`
          );

          if (!card) {
            console.warn(`No product card found for product ID: ${productId}`);
            return;
          }

          const variantWrapper = card.querySelector(".multi_variant_id");
          if (variantWrapper) {
            variantWrapper.setAttribute("data-variant-id", selectedVariantId);
            updateInventoryForCard(card, selectedVariantId);
          }
        });
      });
    });

    // function updateInventoryForCard(card, variantId) {
    //   const selectedLocationId = localStorage.getItem("selected_location");
    //   const inventoryStatus = card.querySelector(".multiloc_inventory-status");
    //   const inventoryContainer = card.querySelector(
    //     ".multiloc_inventory-container"
    //   );

    //   if (
    //     !variantId ||
    //     !window.inventoryData ||
    //     !window.inventoryData.inventoryMap[variantId]
    //   ) {
    //     inventoryStatus.innerHTML = `
    //       <span style="color:gray;">Keine Daten für ausgewählte Variante</span>
    //     `;
    //     return;
    //   }

    //   const variantData = window.inventoryData.inventoryMap[variantId];
    //   inventoryContainer.innerHTML = "";

    //   if (
    //     !variantData.inventoryLevels ||
    //     variantData.inventoryLevels.length === 0
    //   ) {
    //     inventoryStatus.innerHTML = `
    //       <span style="color:gray;">Keine Lagerdaten verfügbar</span>
    //     `;
    //     return;
    //   }

    //   const selectedLocationInventory = variantData.inventoryLevels.filter(
    //     (level) => level.location_id === selectedLocationId
    //   );

    //   if (selectedLocationInventory.length === 0) {
    //     inventoryStatus.innerHTML = `
    //       <span style="display:inline-block; width:10px; height:10px; background-color:#f7931e; border-radius:50%; margin-right:5px;"></span>
    //       <span style="color:#f7931e;">Nicht Verfügbar am gewählten Standort</span>
    //     `;
    //     return;
    //   }

    //   let stockAvailable = false;
    //   let stockother = false;
    //   let locationName = "";

    //   selectedLocationInventory.forEach((level) => {
    //     const { location_name, available_quantity } = level;
    //     const stockLine = document.createElement("div");
    //     stockLine.textContent = `${location_name}: ${
    //       available_quantity > 0 ? "Verfügbar" : "Wir arbeiten an Nachschub"
    //     } (${available_quantity})`;
    //     inventoryContainer.appendChild(stockLine);

    //     if (available_quantity > 0) {
    //       stockAvailable = true;
    //       locationName = location_name;
    //     }
    //     const allLocationsInventory = variantData.inventoryLevels.filter(
    //       (level) => level.available_quantity > 0
    //     );
    //     const otherLocationsWithStock = allLocationsInventory.filter(
    //       (level) =>
    //         String(level.location_id) !== String(selectedLocationId) &&
    //         level.available_quantity > 0
    //     );

    //     if (
    //       !stockAvailable &&
    //       otherLocationsWithStock.length > 0 &&
    //       enabledOtherLocationMessage === "true"
    //     ) {
    //       stockother = true;
    //     }
    //   });

    //   if (stockAvailable) {
    //     inventoryStatus.innerHTML = `
    //       <span style="font-size: 10px;">🟢</span>
    //       <span style="color:#3abf62;font-size:15px;">Verfügbar in ${locationName}</span>
    //     `;
    //   } else {
    //     inventoryStatus.innerHTML = `
    //       <span style="font-size: 10px;">🔴</span>
    //       <span style="color:#ff5858;font-size:15px;">Wir arbeiten an Nachschub</span>
    //     `;
    //   }
    //   if (stockother) {
    //     inventoryStatus.innerHTML = `
    //       <span style="font-size: 10px;">🟠</span>
    //       <span style="color:#FFA500;font-size:15px;">An anderen Standorten verfügbar</span>
    //     `;
    //   }
    // }

    function updateInventoryForCard(card, variantId) {
  try {
    const enabledOtherLocationMessage = window.enabledOtherLocationMessage ?? "true";
    const selectedLocationId = localStorage.getItem("selected_location"); // string
    const inventoryStatus = card.querySelector(".multiloc_inventory-status");
    const inventoryContainer = card.querySelector(".multiloc_inventory-container");

    // --- helper: find all possible add-to-cart buttons ---
    function findAddToCartButtons() {
      let btns = Array.from(card.querySelectorAll(
        "button[name='add'], \
         button.product__add-cart, \
         button.product-item__button-submit, \
         form[action*='/cart/add'] button[type='submit']"
      )).filter(Boolean);
    //  console.log("btns",btns);
      if (btns.length) return btns;

      // fallback: check ancestor card/form
      const anc = card.closest(".product-item, .product-card, .product-card-wrapper, product-form, form");
      if (anc) {
        btns = Array.from(anc.querySelectorAll(
          "button[name='add'], \
           button.product__add-cart, \
           button.product-item__button-submit, \
           form[action*='/cart/add'] button[type='submit']"
        )).filter(Boolean);
        if (btns.length) return btns;
      }

      // last-resort: all add-to-cart buttons on page
      btns = Array.from(document.querySelectorAll(
        "button[name='add'], form[action*='/cart/add'] button[type='submit']"
      )).filter(Boolean);

      return btns;
    }

    const addToCartBtns = findAddToCartButtons();
    // console.log("Found buttons for card:", addToCartBtns);

    // store original text for restoring
    addToCartBtns.forEach((b) => {
      if (!b.dataset.originalText) {
        const span = b.querySelector(".btn-action, .add-to-cart-text, span");
        b.dataset.originalText = span ? span.textContent.trim() : b.textContent.trim();
      }
    });

    function setButtonsDisabled(disabled) {
      addToCartBtns.forEach((btn) => {
        btn.disabled = !!disabled;
        if (disabled) {
          btn.setAttribute("aria-disabled", "true");
          btn.classList.add("is-disabled", "disabled");
          btn.style.opacity = ".5";
          btn.style.pointerEvents = "none";

          const span = btn.querySelector(".btn-action, .add-to-cart-text, span");
          if (span) span.textContent = "Nicht verfügbar";
          else btn.textContent = "Nicht verfügbar";
        } else {
          btn.removeAttribute("aria-disabled");
          btn.classList.remove("is-disabled", "disabled");
          btn.style.opacity = "";
          btn.style.pointerEvents = "";

          const span = btn.querySelector(".btn-action, .add-to-cart-text, span");
          if (span) span.textContent = (btn.dataset.originalText || "Add to Cart");
          else btn.textContent = (btn.dataset.originalText || "Add to Cart");
        }
      });
    }

    // --- Bail if inventory UI missing ---
    if (!inventoryStatus || !inventoryContainer) {
      console.warn("updateInventoryForCard: missing inventory nodes for card", card);
      if (!variantId || !window.inventoryData) setButtonsDisabled(true);
      return;
    }

    // --- No variant / no inventoryData ---
    if (!variantId || !window.inventoryData?.inventoryMap?.[variantId]) {
      inventoryStatus.innerHTML = `<span style="color:gray;">Keine Daten für ausgewählte Variante</span>`;
      setButtonsDisabled(true);
      return;
    }

    const variantData = window.inventoryData.inventoryMap[variantId];
    inventoryContainer.innerHTML = "";

    if (!variantData.inventoryLevels?.length) {
      inventoryStatus.innerHTML = `<span style="color:gray;">Keine Lagerdaten verfügbar</span>`;
      setButtonsDisabled(true);
      return;
    }

    // compare as strings (localStorage = string)
    const selectedLocationInventory = variantData.inventoryLevels.filter(
      (level) => String(level.location_id) === String(selectedLocationId)
    );

    if (selectedLocationInventory.length === 0) {
      inventoryStatus.innerHTML = `
        <span style="display:inline-block; width:10px; height:10px; background-color:#f7931e; border-radius:50%; margin-right:5px;"></span>
        <span style="color:#f7931e;">Nicht Verfügbar am gewählten Standort</span>
      `;
      setButtonsDisabled(true);
      return;
    }

    // --- Build inventory lines ---
    let stockAvailable = false;
    let stockother = false;
    let locationName = "";

    const allLocationsWithStock = variantData.inventoryLevels.filter(l => Number(l.available_quantity) > 0);

    selectedLocationInventory.forEach((level) => {
      const { location_name, available_quantity } = level;
      const stockLine = document.createElement("div");
      stockLine.textContent = `${location_name}: ${available_quantity > 0 ? "Verfügbar" : "Wir arbeiten an Nachschub"} (${available_quantity})`;
      inventoryContainer.appendChild(stockLine);

      if (Number(available_quantity) > 0) {
        stockAvailable = true;
        locationName = location_name;
      }
    });

    const otherLocationsWithStock = allLocationsWithStock.filter(
      (l) => String(l.location_id) !== String(selectedLocationId)
    );

    if (!stockAvailable && otherLocationsWithStock.length > 0 && String(enabledOtherLocationMessage) === "true") {
      stockother = true;
    }

    // --- Update UI & buttons ---
    if (stockAvailable) {
      inventoryStatus.innerHTML = `
        <span style="font-size: 10px;">🟢</span>
        <span style="color:#3abf62;font-size:15px;">Verfügbar in ${locationName}</span>
      `;
      setButtonsDisabled(false);
      return;
    }

    if (stockother) {
      inventoryStatus.innerHTML = `
        <span style="font-size: 10px;">🟠</span>
        <span style="color:#FFA500;font-size:15px;">An anderen Standorten verfügbar</span>
      `;
      setButtonsDisabled(true);
      return;
    }

    inventoryStatus.innerHTML = `
      <span style="font-size: 10px;">🔴</span>
      <span style="color:#ff5858;font-size:15px;">Wir arbeiten an Nachschub</span>
    `;
    setButtonsDisabled(true);
  } catch (err) {
    console.error("updateInventoryForCard error:", err);
  }
}

    // Load More Button logic with unique observer
    const loadMoreBtns = document.querySelectorAll(".actions-loadmore");
    // console.log("loadMoreBtns", loadMoreBtns);
    loadMoreBtns.forEach((loadMoreBtn) => {
      loadMoreBtn.addEventListener("click", async function (e) {
        const loadMoreObserver = new MutationObserver(
          async (mutations, obs) => {
            const addedNodes = [];
            mutations.forEach((mutation) => {
              mutation.addedNodes.forEach((node) => {
                if (
                  node.nodeType === 1 &&
                  node.matches(".multilocation_product-card[data-product-id]")
                ) {
                  addedNodes.push(node);
                } else if (node.nodeType === 1 && node.querySelectorAll) {
                  const nestedCards = node.querySelectorAll(
                    ".multilocation_product-card[data-product-id]"
                  );
                  addedNodes.push(...nestedCards);
                }
              });
            });

            if (addedNodes.length > 0) {
              obs.disconnect();
              await updateCollectionInventory(addedNodes);
            }
          }
        );

        const productList = document.querySelector(
          ".product-grid, .product-list, .collection-products"
        );
        if (productList) {
          loadMoreObserver.observe(productList, {
            childList: true,
            subtree: true,
          });
        }
      });
    });

    let isInventoryFetchInProgress = false; // Flag to prevent multiple API calls
    let updateInventoryTimeout = null; // For debouncing

    async function updateCollectionInventory() {
      // Clear any existing timeout
      if (updateInventoryTimeout) {
        clearTimeout(updateInventoryTimeout);
      }

      // Debounce the function call
      return new Promise((resolve) => {
        updateInventoryTimeout = setTimeout(async () => {
          if (isInventoryFetchInProgress) {
            console.log("Inventory fetch already in progress. Skipping...");
            resolve();
            return;
          }

          isInventoryFetchInProgress = true; // Set the flag to true
      const selectedLocationId = localStorage.getItem("selected_location");
      const productCards = document.querySelectorAll(
        ".multilocation_product-card[data-product-id]"
      );
      const productId = Array.from(productCards)
        .map((card) => card.getAttribute("data-product-id"))
        .filter(Boolean)
        .join(",");

      if (!productId) {
        console.error("No product ID found.");
        isInventoryFetchInProgress = false; // Reset the flag
        return;
      }

      try {
        const response = await fetch(
          `https://multilocation.techspawn.net/api/get-collection-product-inventory?shopdomain=${encodeURIComponent(
            shopdomain
          )}&productId=${productId}`
        );

        if (!response.ok) {
          console.error(
            `Failed to fetch inventory data. Status: ${response.status}`
          );
          isInventoryFetchInProgress = false; // Reset the flag
          return;
        }

        const data = await response.json();

        if (!data || typeof data !== "object") {
          console.error("Invalid data structure received from the API.");
          isInventoryFetchInProgress = false; // Reset the flag
          return;
        }

        window.inventoryData = data;

        productCards.forEach((card) => {
          const variantWrapper = card.querySelector(".multi_variant_id");
          const variantId = variantWrapper?.getAttribute("data-variant-id");

          if (!variantId || !data.inventoryMap[variantId]) {
            // console.warn(`No inventory data for variantId: ${variantId}`);
            return;
          }

          updateInventoryForCard(card, variantId);
        });
        
        // Use cached inventory data instead of fetching again
        const allInvntoryData = globalInventoryDataCache || await getloc_inventory_stock();
        const pushDownOutofStockItems =
          allInvntoryData?.settings?.pushDownOutofStockItems;
        function getInventoryForLocation(variantId, locationId) {
          const inventoryMap = window.inventoryData?.inventoryMap || {};
          const variantEntry = inventoryMap[variantId];

          if (!variantEntry || !variantEntry.inventoryLevels) return -1;

          const level = variantEntry.inventoryLevels.find(
            (lvl) => lvl.location_id === locationId
          );
          return level ? level.available_quantity : -1;
        }

        function sortProductsByLocationInventory() {
          const selected_location = localStorage.getItem("selected_location");
          if (!selected_location) {
            console.error("[Inventory Sort] No selected_location found");
            return;
          }

          // Look for all multi_variant_id elements with data-variant-id
          const variantNodes = Array.from(
            document.querySelectorAll(".multi_variant_id[data-variant-id]")
          );
          if (variantNodes.length === 0) {
            console.error(
              "[Inventory Sort] No .multi_variant_id with data-variant-id found"
            );
            return;
          }
          const variantDataMap = new Map();

          for (const variantEl of variantNodes) {
            const variantId = variantEl.dataset.variantId;
            if (!variantId) continue;

            const inventoryQty = getInventoryForLocation(
              variantId,
              selected_location
            );

            // Support any of these container types: li.grid__item, div.grid__item, or .product-item-sort
            const parentItem = variantEl.closest(
              "li.grid__item, div.grid__item, .product-item-sort"
            );
            if (!parentItem) {
              // console.warn(
              //   `[Inventory Sort] No matching parent container for variantId ${variantId}`
              // );
              continue;
            }

            variantDataMap.set(parentItem, inventoryQty);
          }

          const sortedItems = [...variantDataMap.entries()]
            .sort(([, a], [, b]) => (b || -1) - (a || -1))
            .map(([item]) => item);

          if (sortedItems.length > 0) {
            const parentContainer = sortedItems[0].parentNode;
            sortedItems.forEach((item) => parentContainer.appendChild(item));
            console.log(
              "[Inventory Sort] Products re-sorted by inventory at location:",
              selected_location
            );
          }
        }
        document
          .querySelectorAll("li.grid__item, div.grid__item, .multi_variant_id")
          .forEach((variantWrapper) => {
            setTimeout(() => {
              if (
                pushDownOutofStockItems === true ||
                pushDownOutofStockItems === "true"
              ) {
                sortProductsByLocationInventory();
              }
            }, 100);
          });
      } catch (error) {
        console.error("Error fetching inventory data:", error);
      } finally {
        isInventoryFetchInProgress = false; // Reset the flag
        resolve();
      }
        }, 100); // 100ms debounce delay
      });
    }

    // Single initialization call after all setup is complete
    setTimeout(async () => {
      await updateCollectionInventory();
    }, 300);

    document.addEventListener("updateCollectionInventory", function () {
      const selectedLocationId = localStorage.getItem("selected_location");
      if (selectedLocationId && isCollectionPage()) {
        setTimeout(() => updateCollectionInventory(), 50);
        if (
          enabledSmartCollectionFilter === true ||
          enabledSmartCollectionFilter === "true"
        ) {
          const locationshowonheader = document.getElementById(
            "location-popup-header-id"
          );
          console.log("locationshowonheader_run2", locationshowonheader);
          const locationname = locationshowonheader.textContent;
          console.log(locationname);
          updateFilterURL(locationname);
          applyShopifyFilter();
        }
      }
    });
    const quantityElements = document.querySelectorAll(
      ".quantity_showing_color"
    );
    quantityElements.forEach(function (quantityElement) {
      const quantity = parseInt(quantityElement.textContent.trim());
      if (quantity > 10) {
        quantityElement.classList.add("stock-green");
      } else if (quantity > 0) {
        quantityElement.classList.add("stock-yellow");
      } else {
        quantityElement.classList.add("stock-red");
      }
    });
  }
setInterval(() => {
  const elements = document.querySelectorAll(".location-card-drawer-list-view-address");
 
  elements.forEach(elem => {
    if (!elem.dataset.modified) {
      const lines = elem.innerHTML.split("<br>");
        // console.log("lines",lines.length);
      if(lines.length == 4){
        const line1 = lines[0] ? lines[0].trim() : "";
        const line2 = lines[1] ? lines[1].trim() : "";
        elem.textContent = `${line1}`;
        elem.dataset.modified = "true";
      } else if(lines.length == 5){
        const line1 = lines[0] ? lines[0].trim() : "";
        const line2 = lines[1] ? lines[1].trim() : "";
        elem.textContent = `${line1} ${line2}`; 
        elem.dataset.modified = "true";
      }
    }
  });
}, 500); 
});
